const Terms = () => {
   return (
      <div className="bg-[#18191d] flex flex-col items-center justify-center">
         <a href="/">
            <img
               width={'165px'}
               src="/images/fff-logo.png"
               className="md:absolute left-10 top-10"
               alt="ff icon"
            />
         </a>
         <div className="max-w-[60%] text-left my-8 leading-6 mt-40">
            <p className="mb-10 text-3xl font-semibold text-center">
               User Agreement
            </p>
            <p className="mb-3">Last Updated: Nov 11, 2024</p>
            <p className="mb-3">
               These User Agreement apply to Forward Flow, LLC Inc. online and
               mobile sites and apps on which these User Agreement are posted.
               Our User Agreement is a contract for the Forward Flow, LLC's
               teame of Forward Flow, LLC’s offerings.
            </p>
            <p className="mb-3">
               Our contact form allows Forward Flow, LLC's team to obtain
               yForward Flow, LLC's contact information for Forward Flow, LLC's
               team to contact the user about the purchase of Forward Flow,
               LLC's products or services. Our team will reach out to the user
               and discForward Flow, LLC's teams options including payment
               methods, subscription terms, and products purchased.
            </p>
            <p className="mb-3">
               You agree that by clicking &quot;Sign Up&quot;, &quot;Get
               Started&quot;, or registering, accessing, or Forward Flow, LLC's
               teaming Forward Flow, LLC's offerings, as defined below, the user
               are entering into a legally binding agreement. If the user do not
               agree to this Agreement, do NOT click &quot;Sign Up&quot;,
               &quot;Get Started&quot; (or similar), and do not access or
               otherwise Forward Flow, LLC's teame any of Forward Flow, LLC's
               offerings.
            </p>
            <p className="mb-3">
               We reserve the right, in Forward Flow, LLC's sole discretion, to
               modify or replace any of these User Agreement or change, sForward
               Flow, LLC's teampend, limit, or discontinue the offerings
               (including, without limitation, the availability of any feature,
               database, or content) at any time. If Forward Flow, LLC's
               organization deem any modification or update to these User
               Agreement are material, Forward Flow, LLC's organization will
               post a notice on the Site or send the user notice by another
               appropriate means of electronic communication. It is yForward
               Flow, LLC's responsibility to check these User Agreement
               periodically for changes. YForward Flow, LLC's continued Forward
               Flow, LLC's teame of the offerings following posting or
               notification of any changes to these User Agreement constitutes
               acceptance of those changes.
            </p>
            <p className="mb-3">Table of Contents</p>
            <p className="mb-3">Definitions</p>
            <p className="mb-3">Account Registration</p>
            <p className="mb-3">Acceptable Use of offerings</p>
            <p className="mb-3">offerings</p>
            <p className="mb-3">Support offerings</p>
            <p className="mb-3">Payment and Fees</p>
            <p className="mb-3">Content and Ownership</p>
            <p className="mb-3">
               Loss of Data, Content, and Capacity Upon Cancellation
            </p>
            <p className="mb-3">Third Party offerings</p>
            <p className="mb-3">
               Equal HoForward Flow, LLC's teaming Opportunity
            </p>
            <p className="mb-3">Copyrights and DMCA</p>
            <p className="mb-3">Termination</p>
            <p className="mb-3">
               Privacy and yForward Flow, LLC's Personal Information
            </p>
            <p className="mb-3">Indemnification</p>
            <p className="mb-3">Disclaimer of Warranties</p>
            <p className="mb-3">Limitation of Liability</p>
            <p className="mb-3">Governing Law and Jurisdiction</p>
            <p className="mb-3">General</p>
            <p className="mb-3">User Disputes</p>
            <p className="mb-3">MiscellaneoForward Flow, LLC's team</p>
            <p className="mb-3">Contact Us</p>
            <p className="mb-3">1. Definitions</p>
            <p className="mb-3">
               The following terms are defined for the purpose of this
               Agreement:
            </p>
            <p className="mb-3">
               “Account”&nbsp;- means a registered Forward Flow, LLC's teamer
               account.
            </p>
            <p className="mb-3">
               “Add-Ons”&nbsp;- additional Forward Flow, LLC products and
               services that can be purchased from within the Forward Flow, LLC
               Platform.
            </p>
            <p className="mb-3">
               “Agreement”&nbsp;- means these User Agreement and all materials
               referred to or linked to herein.
            </p>
            <p className="mb-3">
               “Applicability”&nbsp;- means these User Agreement apply to all
               Forward Flow, LLC's teamers of the offerings.
            </p>
            <p className="mb-3">
               &quot;Forward Flow, LLC&quot;, &quot;Forward Flow, LLC's
               organization&quot;, &quot;Forward Flow, LLC's team&quot;, or
               “Forward Flow, LLC's”&nbsp;- means Forward Flow, LLC Inc. and any
               subsidiary Sites.
            </p>
            <p className="mb-3">
               “Forward Flow, LLC Marketplace”&nbsp;- refers to the section and
               pages within the Forward Flow, LLC CRM that provide an authorized
               Member with access to purchase Add-Ons or Third-Party offerings.
            </p>
            <p className="mb-3">
               “CRM” or “Forward Flow, LLC CRM”&nbsp;- CRM stands for CForward
               Flow, LLC's teamtomer Relationship Management. In the context of
               Forward Flow, LLC, “CRM” refers to the CRM built, operated, and
               maintained by Forward Flow, LLC and provided as part of
               offerings.
            </p>
            <p className="mb-3">
               “Lead(s)”&nbsp;- means property buyers, sellers, and/or renters
               and their basic contact information. Potential cForward Flow,
               LLC's teamtomers for real estate professionals inquiring about
               real estate information. Leads may also refer to other contacts
               recorded in the Forward Flow, LLC platform for the benefit of the
               Member.
            </p>
            <p className="mb-3">
               &quot;Members”, “Member Account”, or&nbsp;“Users&quot;&nbsp;-
               means registered Forward Flow, LLC's teamers who are authorized
               to Forward Flow, LLC's teame the subscription service for
               yForward Flow, LLC's benefit and have unique Forward Flow, LLC's
               teamer identifications and passwords for the subscription
               service.
            </p>
            <p className="mb-3">
               “Member platform”&nbsp;- means a real estate Forward Flow, LLC's
               organizationbsite built and maintained by Forward Flow, LLC as
               part of offerings offered. Only Members who have purchased a
               Member platform will have access to one.
            </p>
            <p className="mb-3">
               “Member Content”&nbsp;- any content provided by a Member for
               Forward Flow, LLC's teame within the Forward Flow, LLC offerings.
            </p>
            <p className="mb-3">
               “MLS”&nbsp;- means multiple listing service (MLS), which is a
               database established by cooperating real estate brokers to
               provide data about properties for sale and or for
               rent.&nbsp;“Personal Information”&nbsp;- information that
               identifies an individual and is associated with a specific
               person.
            </p>
            <p className="mb-3">
               “Platform”&nbsp;- means the Forward Flow, LLC Forward Flow, LLC's
               teamer interface the user utilize to access Forward Flow, LLC
               offerings.
            </p>
            <p className="mb-3">
               “Real Estate platform”&nbsp;- a Forward Flow, LLC's
               organizationbsite utilized by real estate professionals for the
               purpose of engaging and servicing real estate Leads. In the
               context of Forward Flow, LLC, “Real Estate platform” refers to a
               Forward Flow, LLC's organizationbsite built, operated, and
               maintained by Forward Flow, LLC and provided as part of
               offerings.
            </p>
            <p className="mb-3">
               “offerings”&nbsp;- Forward Flow, LLC’s products and services
               provided to authorized Member accounts.
            </p>
            <p className="mb-3">
               “Sites”&nbsp;- are online and mobile sites and apps operated by
               Forward Flow, LLC Inc. along with Forward Flow, LLC's affiliates
               including Geographic Farming, LLC (&quot;GeoFarm&quot;) and
               subsidiary sites including Forward Flow, LLC.me and Forward Flow,
               LLCroi.com.
            </p>
            <p className="mb-3">
               “Subscription Agreement”&nbsp;- the contractual agreement
               betForward Flow, LLC's organizationen Forward Flow, LLC and
               Members that defines offerings to be provided, their cost, and
               the duration of the agreement.
            </p>
            <p className="mb-3">
               “Subscription”&nbsp;- refers to the access provided by Forward
               Flow, LLC to Members based on the terms of the Subscription
               Agreement.
            </p>
            <p className="mb-3">
               &quot;Third-Party Sites&quot;, “Third-Party offerings”, “Third
               Party Sites”, or&nbsp;“Third Party offerings”&nbsp;- means
               third-party Forward Flow, LLC's organizationbsites and services
               linked to within the offerings.
            </p>
            <p className="mb-3">
               “Visitors”&nbsp;- means unregistered or non-registered Forward
               Flow, LLC's teamers.
            </p>
            <p className="mb-3">
               &quot;You&quot;, &quot;yForward Flow, LLC's&quot;,
               or&nbsp;“CForward Flow, LLC's teamtomer”&nbsp;- means the person
               or entity Forward Flow, LLC's teaming the offerings and
               identified in the applicable account record, billing statement,
               online subscription process, or contact form as the cForward
               Flow, LLC's teamtomer.
            </p>
            <p className="mb-3">2. Account Registration</p>
            <p className="mb-3">
               To utilize certain offerings, the user will be required to
               register for an account. You mForward Flow, LLC's teamt provide
               accurate and complete information and keep yForward Flow, LLC's
               Account information updated.
            </p>
            <p className="mb-3">
               You are solely responsible for the activity that occurs on
               yForward Flow, LLC's Account and for keeping yForward Flow, LLC's
               Account password secure. You may never Forward Flow, LLC's teame
               another person’s Forward Flow, LLC's teamer account or
               registration information for the offerings. You mForward Flow,
               LLC's teamt notify Forward Flow, LLC's team immediately of any
               change in yForward Flow, LLC's eligibility to Forward Flow, LLC's
               teame the offerings, any breach of security, or any unauthorized
               Forward Flow, LLC's teame of yForward Flow, LLC's Account. You
               should never publish, distribute, or post login information for
               yForward Flow, LLC's Account.
            </p>
            <p className="mb-3">
               More information regarding the privacy of yForward Flow, LLC's
               account can be found in Forward Flow, LLC’s&nbsp;Data Protection
               Guidelines.
            </p>
            <p className="mb-3">3. Acceptable Use of offerings</p>
            <p className="mb-3">3.1</p>
            <p className="mb-3">
               You mForward Flow, LLC's teamt provide accurate and complete
               information when registering yForward Flow, LLC's Member Account
               and Forward Flow, LLC's teaming the offerings, to which the user
               are the sole and exclForward Flow, LLC's teamive rights holder.
               You represent and warrant that:
            </p>
            <p className="mb-3">
               the user are at least eighteen (18) years of age and that the
               user have the right, authority, and capacity to enter into,
               perform yForward Flow, LLC's obligations under, and abide by
               these User Agreement. If the user are under the age of 18, the
               user may not, under any circumstances or for any reason, Forward
               Flow, LLC's teame the offerings;
            </p>
            <p className="mb-3">
               the user are not (a) a resident of (nor will the user Forward
               Flow, LLC's teame the offerings in) any country that the U.S.
               government has imposed embargo sanctions for Forward Flow, LLC's
               teame of the offerings, (b) named on the U.S. Treasury
               Department's list of Specially Designated Nationals or any other
               applicable trade sanctioning regulations;
            </p>
            <p className="mb-3">
               the user will fully comply with all applicable laws and
               agreements which govern yForward Flow, LLC's Forward Flow, LLC's
               teame of the offerings.
            </p>
            <p className="mb-3">3.2</p>
            <p className="mb-3">
               You acknowledge and agree that Forward Flow, LLC's organization
               shall determine the means, manner, and method for performing the
               offerings, including those regarding the hosting, transmission,
               publication and/or display of any Member platforms and/or Member
               Content (including the inclForward Flow, LLC's teamion and
               presentation of any advertisements or other commercial content
               with respect thereto).
            </p>
            <p className="mb-3">3.3</p>
            <p className="mb-3">
               When accessing Forward Flow, LLC's offerings, the user undertake
               and agree NOT to:
            </p>
            <p className="mb-3">
               Take any action in violation of these User Agreement;
            </p>
            <p className="mb-3">
               Copy, modify, create derivative works of, download, adapt,
               reverse engineer, emulate, migrate to another service, translate,
               compile, decompile or disassemble any of the Sites, the offerings
               (or any part thereof), any content offered by Forward Flow, LLC's
               team or Third Party offerings for Forward Flow, LLC's teame and
               display within Member platforms (&quot;Licensed Content&quot;)
               except as expressly permitted under this Agreement;
            </p>
            <p className="mb-3">
               Publish and/or make any Forward Flow, LLC's teame of the
               offerings or Licensed Content on any Forward Flow, LLC's
               organizationbsite, media, network or system other than those
               provided by Forward Flow, LLC's team, and/or frame, &quot;deep
               link&quot;, &quot;page scrape&quot;, mirror and/or create a
               browser or border environment around any of the offerings,
               Licensed Content and/or Member platform (or any part thereof);
            </p>
            <p className="mb-3">
               Use any &quot;robot&quot;, &quot;spider&quot; or other automatic
               device, program, script, algorithm, or methodology, or any
               similar or equivalent manual process, to access, acquire, copy,
               or monitor any portion of the offerings (or any of its data), or
               in any way reproduce or circumvent the navigational structure or
               presentation of any of the offerings to obtain or attempt to
               obtain any materials, documents, services or information through
               any means not purposely made available through the offerings;
            </p>
            <p className="mb-3">
               Purchase search engine or other pay per click keywords (such as
               Google AdWords), or domain names that Forward Flow, LLC's teame
               Forward Flow, LLC's name or Forward Flow, LLC's Marks and/or
               variations and misspellings thereof;
            </p>
            <p className="mb-3">
               Impersonate any person or entity or provide false information on
               the offerings and/or Member platform, whether directly or
               indirectly, or otherwise disguise yForward Flow, LLC's identity
               or the origin of any message or transmittal the user send to
               Forward Flow, LLC's team and/or any of Forward Flow, LLC's other
               Visitors or Members;
            </p>
            <p className="mb-3">
               Falsely state or otherwise misrepresent yForward Flow, LLC's
               affiliation with any person or entity, or falsely express or
               imply that Forward Flow, LLC's organization or any third party
               endorses the user, yForward Flow, LLC's Member platform, yForward
               Flow, LLC's bForward Flow, LLC's teaminess, yForward Flow, LLC's
               products or services, or any statement the user make;
            </p>
            <p className="mb-3">
               Reverse look-up, trace, or seek to trace another Member of
               offerings, or otherwise interfere with or violate any other
               Member's right to privacy or other rights, or harvest or collect
               personally identifiable information about visitors or Forward
               Flow, LLC's teamers of the offerings and/or Member platform
               without their express and informed consent;
            </p>
            <p className="mb-3">
               Disable, circumvent, bypass or otherwise avoid any measures
               Forward Flow, LLC's teamed to prevent or restrict access to the
               offerings, Member platform, the account of another Member or any
               other systems or networks connected to the offerings, by hacking,
               password mining, or other illegitimate or prohibited means;
            </p>
            <p className="mb-3">
               Probe, scan, or test the vulnerability of the offerings or any
               network connected to the offerings;
            </p>
            <p className="mb-3">
               Upload to the offerings and/or Member platform or otherwise
               Forward Flow, LLC's teame them to design, develop, distribute
               and/or otherwise transmit or execute, any virForward Flow, LLC's
               team, worm, Trojan Horse, time bomb, Forward Flow, LLC's
               organizationb bug, spyware, malware, or any other computer code,
               file, or program that may or is intended to damage or hijack the
               operation of any hardware, software, or telecommunications
               equipment, or any other actually or potentially harmful,
               disruptive, or invasive code or component;
            </p>
            <p className="mb-3">
               Take any action that may impose an unreasonable or
               disproportionately large load on the infrastructure of the
               offerings or Forward Flow, LLC's systems or networks connected to
               the offerings, or otherwise interfere with or disrupt the
               operation of any of the offerings, or the servers or networks
               that host them or make them available, or disobey any
               requirements, procedures, policies, or regulations of such
               servers or networks;
            </p>
            <p className="mb-3">
               Interfere or attempt to interfere with the proper working of the
               offerings or any activities conducted in connection with the
               offerings;
            </p>
            <p className="mb-3">
               Use any of the offerings and/or Member platform in connection
               with any form of spam, unsolicited mail, fraud, scam, phishing,
               &quot;chain letters&quot;, &quot;pyramid schemes&quot; or similar
               conduct, or otherwise engage in unethical marketing or
               advertising;
            </p>
            <p className="mb-3">
               Sell, license, or exploit for any commercial purposes any Forward
               Flow, LLC's teame of or access to the Licensed Content and/or
               offerings, except as expressly permitted by this Agreement;
            </p>
            <p className="mb-3">
               Remove or alter any copyright notices, watermarks, restrictions
               and signs indicating proprietary rights of any of Forward Flow,
               LLC's licensors, including copyright mark [©] or trademarks [® or
               ™] contained in or accompanying the offerings and/or Licensed
               Content;
            </p>
            <p className="mb-3">
               XVII.Infringe any patent, trademark, trade secret, copyright,
               right of publicity, or other right of any other person or entity
               or violates any law or contractual duty;
            </p>
            <p className="mb-3">
               Recruit, solicit, or encForward Flow, LLC'sage any other Forward
               Flow, LLC's teamer to Forward Flow, LLC's teame third party
               services or Forward Flow, LLC's organizationbsites that are
               competitive to Forward Flow, LLC'ss;
            </p>
            <p className="mb-3">
               Copy, rent, lease, distribute, or otherwise transfer any of the
               rights that the user receive hereunder. You shall abide by all
               applicable local, state, national, and international laws and
               regulations.
            </p>
            <p className="mb-3">
               Use the offerings for any purpose that is prohibited by these
               User Agreement. You are responsible for all of yForward Flow,
               LLC's activity in connection with the offerings.
            </p>
            <p className="mb-3">3.4</p>
            <p className="mb-3">
               You acknowledge and agree that yForward Flow, LLC's failure to
               abide by any of the foregoing or any misrepresentation made by
               the user may result in the immediate termination of yForward
               Flow, LLC's Member Account and/or any offerings provided to the
               user, with or without further notice to the user, and without any
               refund of amounts paid on account of any such offerings.
            </p>
            <p className="mb-3">3.5</p>
            <p className="mb-3">
               ACCEPTABLE EMAIL &amp; COMMUNICATION POLICY. Forward Flow, LLC
               prohibits the Forward Flow, LLC's teame of any provided offerings
               being involved in or utilized for Unsolicited Commercial Email
               (“UCE” or “spam”). You understand and agree to the following:
            </p>
            <p className="mb-3">
               Due to a zero-tolerance policy against spam, Forward Flow, LLC
               reserves the right to paForward Flow, LLC's teame and/or disable
               email communication tools available in the provided offerings
               should it be determined that spam content is being sent.
            </p>
            <p className="mb-3">
               Prior to importing an existing list of contacts/leads, the user
               mForward Flow, LLC's teamt ensure that those on the list are
               expecting to hear from the user and yForward Flow, LLC's
               organization.
            </p>
            <p className="mb-3">
               Regardless of origin/sForward Flow, LLC'sce, the Member is
               responsible to maintain records/evidence/proof that all
               individuals in their database have agreed or opted-in to receive
               communication from the Member or their organization. Forward
               Flow, LLC can request evidence showing that the Member is
               compliant with opt-in obligations at any time.
            </p>
            <p className="mb-3">
               All email messages sent via the provided offerings mForward Flow,
               LLC's teamt contain (a) a link for the Forward Flow, LLC's teame
               of recipients of email communication sent by Members to
               “unsubscribe” or “opt-out,” (b) a valid physical address for the
               sender, and (c) a subject line that does not mislead or
               misrepresent the content of the email or the intentions of the
               Member sending it. The “unsubscribe” action provided by the
               offerings is processed immediately.
            </p>
            <p className="mb-3">
               When applicable, the ability to “re-subscribe” an individual via
               the provided offerings mForward Flow, LLC's teamt only be done
               with clear records/evidence/proof indicating that the individual
               re-subscribed at their request.
            </p>
            <p className="mb-3">
               The “feedback rate” (“complaint rate”) may not exceed the
               standards maintained by the provided offerings or the email
               provider tools utilized in the offerings to process
               (send/receive) email communication. Should the feedback rate
               exceed the established standards, Forward Flow, LLC reserves the
               right to paForward Flow, LLC's teame, disable, or make
               technological adjForward Flow, LLC's teamtments that will affect
               email communication tools available to the Member in the provided
               offerings.
            </p>
            <p className="mb-3">
               You are encForward Flow, LLC'saged to consult with legal counsel
               to ensure compliance with local, state, and federal laws.
            </p>
            <p className="mb-3">3.6</p>
            <p className="mb-3">
               DO NOT CONTACT. Forward Flow, LLC prohibits the Forward Flow,
               LLC's teame of any provided offerings being involved in or
               utilized for call or text (SMS) communication that is not
               compliant with applicable state, federal, or international laws
               or regulations. You understand and agree to the following:
            </p>
            <p className="mb-3">
               YForward Flow, LLC's Compliance Obligations Regarding
               Telemarketing, Do-Not-Call, and other Laws and Regulations
               Applicable to YForward Flow, LLC's Use of the offerings: YOU
               ACKNOWLEDGE THAT YOUR USE OF THE SERVICES MAY BE SUBJECT TO ONE
               OR MORE STATE AND FEDERAL LAWS AND REGULATIONS GOVERNING
               TELEMARKETING ACTIVITIES, INCLUDING LAWS AND REGULATIONS
               ADMINISTERED BY THE FEDERAL COMMUNICATIONS COMMISSION AND THE
               FEDERAL TRADE COMMISSION, AS WELL AS STATE ATTORNEYS GENERAL AND
               OTHER STATE REGULATORS AND REGULATORS IN THE EUROPEAN UNION AND
               OTHER INTERNATIONAL BODIES. YOU REPRESENT AND WARRANT THAT YOU
               WILL BE IN COMPLIANCE WITH ALL SUCH LAWS AND REGULATIONS IN YOUR
               USE OF ANY PART OF THE SERVICES, AND YOU ACKNOWLEDGE AND AGREE
               THAT YOU HAVE UNDERTAKEN INDEPENDENT EFFORTS TO CONFIRM YOUR
               COMPLIANCE WITH SUCH LAWS AND REGULATIONS AND HAVE NOT IN ANY WAY
               RELIED ON ANY COMMUNICATION BY US, WHETHER ORAL OR IN WRITING,
               REGARDING SUCH COMPLIANCE BY YOU.
            </p>
            <p className="mb-3">
               You assume all liability and responsibility for operating the
               offerings according to applicable international, federal, state,
               provincial, or local laws, regulations, rules, and requirements
               and any other laws, regulations, rules, and requirements
               regarding data privacy, telemarketing, recording conversations,
               consumer protection, the Forward Flow, LLC's teame of automatic
               telephone dialing systems, text messaging, or e-mail. You are
               aware that such laws include rules, regulations, and limitations
               regarding commercial solicitations and/or the making of
               prerecorded, artificial voice, and autodialed telephonic messages
               or text messages to homes and bForward Flow, LLC's teaminesses
               without the prior express and/or prior express written consent of
               the called party. You are aware that such laws also include
               rules, regulations, and limitations regarding commercial
               solicitations to homes and bForward Flow, LLC's teaminesses that
               have opted into a state or federal do not call registry. You are
               also aware that such laws may require the user to obtain a
               license or otherwise register with a government or regulatory
               body prior to operating the offerings. You acknowledge that the
               user understand that the violation of any such laws may result in
               significant penalties and other sanctions. You further
               acknowledge and agree that the user should consult with yForward
               Flow, LLC's own counsel, prior to Forward Flow, LLC's teaming the
               offerings, to determine the extent of permissible solicitation
               activities. You agree to Forward Flow, LLC's teame this product
               in accordance with all legal requirements. Forward Flow, LLC will
               not be responsible for any illegal Forward Flow, LLC's teame of
               its services. You are responsible for all insurance, tax, and
               license requirements applicable to yForward Flow, LLC's Forward
               Flow, LLC's teame of the offerings.
            </p>
            <p className="mb-3">
               Do Not Call compliance, including compliance with state DNC laws,
               is solely the responsibility of the user, the CForward Flow,
               LLC's teamtomer. Forward Flow, LLC is not responsible for any
               cForward Flow, LLC's teamtomer misForward Flow, LLC's teame,
               intentional or unintentional, of any data provided, including DNC
               data.
            </p>
            <p className="mb-3">3.7</p>
            <p className="mb-3">
               APPROVED ACCOUNT ACCESS. In order for Forward Flow, LLC to
               provide support for offerings, the Forward Flow, LLC Support Team
               and others employed within the Forward Flow, LLC organization can
               be granted permission to access yForward Flow, LLC's individual
               Forward Flow, LLC's teamer account via yForward Flow, LLC's
               account preferences. You understand that for Forward Flow, LLC to
               be able to fully address yForward Flow, LLC's questions or
               concerns, access mForward Flow, LLC's teamt be granted to Forward
               Flow, LLC. If access is not provided, Forward Flow, LLC will be
               unable to fully-diagnose any potential issues and is not liable
               for loss of functionality on yForward Flow, LLC's account Forward
               Flow, LLC's organizationre access enabled. If, for whatever
               reason, the user are unable to grant Forward Flow, LLC permission
               to access yForward Flow, LLC's Forward Flow, LLC's teamer
               account, please send written permission to override via email to
               the Forward Flow, LLC Support Team ().
            </p>
            <p className="mb-3">
               Certain Forward Flow, LLC configurations within Forward Flow,
               LLC's offerings enable account owners and their designated admins
               with access to log into yForward Flow, LLC's individual Forward
               Flow, LLC's teamer account as a member of their account for the
               purpose of providing support and participating in the
               configuration of yForward Flow, LLC's account. By utilizing
               Forward Flow, LLC’s offerings, the user agree to allow this
               access if applicable to the configuration options available
               within yForward Flow, LLC's account.
            </p>
            <p className="mb-3">3.8</p>
            <p className="mb-3">
               We may, in Forward Flow, LLC's sole discretion, refForward Flow,
               LLC's teame to offer the offerings to any person or entity and
               change its eligibility criteria at any time. You are solely
               responsible for ensuring that yForward Flow, LLC's Forward Flow,
               LLC's teame of the offerings under these User Agreement is
               compliant with all laws, rules, and regulations applicable to the
               user. The right to access the offerings is revoked where Forward
               Flow, LLC's teame of the offerings is prohibited or to the extent
               offering, sale or provision of the offerings conflicts with any
               applicable law, rule, or regulation. Further, unless otherwise
               mutually agreed in writing, the offerings are offered only for
               yForward Flow, LLC's Forward Flow, LLC's teame and not for the
               Forward Flow, LLC's teame or benefit of any third party; and in
               any event, each person receiving the benefit of the offerings
               mForward Flow, LLC's teamt agree to and abide by these User
               Agreement as a condition to Forward Flow, LLC's obligations.
            </p>
            <p className="mb-3">3.9</p>
            <p className="mb-3">
               NON-U.S. USERS. To facilitate Forward Flow, LLC's bForward Flow,
               LLC's teaminess practices, yForward Flow, LLC's Personal Data
               will be collected, transferred to, and stored by Forward Flow,
               LLC's team in the United States. The offerings are controlled and
               offered by Forward Flow, LLC's team from Forward Flow, LLC's
               facilities or contracted facilities and server providers in the
               United States. We make no representations that the offerings are
               appropriate or available for Forward Flow, LLC's teame in other
               locations. Those who access or Forward Flow, LLC's teame the
               offerings from other jurisdictions do so at their own risk and
               are responsible for ensuring compliance with local laws. By
               providing information in connection with the offerings, the user
               consent to the transfer of yForward Flow, LLC's information to,
               and storage of yForward Flow, LLC's information in, the United
               States, the laws of which may not be as stringent as the laws of
               the country in which the user reside. Please refer to Forward
               Flow, LLC’s&nbsp;Data Protection Guidelines&nbsp;for additional
               details.
            </p>
            <p className="mb-3">3.10</p>
            <p className="mb-3">
               FORWARDFLOW’S ADDITIONAL RIGHTS. We also reserve the right,
               without any obligation, to access, read, preserve, and disclose
               any information as Forward Flow, LLC's organization reasonably
               believe is necessary to:
            </p>
            <p className="mb-3">
               satisfy any applicable law, regulation, legal process or
               governmental request;
            </p>
            <p className="mb-3">
               enforce these User Agreement, including investigation of
               potential violations hereof;
            </p>
            <p className="mb-3">
               detect, prevent, or otherwise address fraud, security or
               technical issues;
            </p>
            <p className="mb-3">
               respond to Forward Flow, LLC's teamer support requests;
            </p>
            <p className="mb-3">
               fulfill yForward Flow, LLC's requests for services;
            </p>
            <p className="mb-3">
               protect the rights, property or safety of Forward Flow, LLC's
               team, Forward Flow, LLC's Forward Flow, LLC's teamers, and the
               public.
            </p>
            <p className="mb-3">3.11</p>
            <p className="mb-3">
               ACCESSIBILITY. Forward Flow, LLC is committed to ensuring Forward
               Flow, LLC's offerings are accessible for everyone including those
               with disabilities. We continue to make every effort to reach the
               Level AA standards that defined by the Web Content Accessibility
               Guidelines to improve accessibility for individuals with
               disabilities. NumeroForward Flow, LLC's team improvements have
               been made, some are in progress, and others will continue to be
               addressed in the future. Forward Flow, LLC commits to continue
               improving Forward Flow, LLC's organizationbsite accessibility on
               an ongoing basis.
            </p>
            <p className="mb-3">
               If the user, as a Forward Flow, LLC Forward Flow, LLC's teamer,
               need assistance in addressing accessibility requests from site
               visitors or would like to submit feedback and/or recommendations
               to make yForward Flow, LLC's Forward Flow, LLC's
               organizationbsite more accessible, please send an email to
               Forward Flow, LLC's Support Team (). We will do Forward Flow,
               LLC's best to produce accessible versions of content to address
               specific needs.
            </p>
            <p className="mb-3">4. offerings</p>
            <p className="mb-3">4.1</p>
            <p className="mb-3">
               FORWARDFLOW CRM. Forward Flow, LLC will provide the user with the
               number of Forward Flow, LLC CRM (“Forward Flow, LLC CRM”)
               instances that is defined in yForward Flow, LLC's Subscription
               Agreement with Forward Flow, LLC. With some Forward Flow, LLC
               packages, additional Forward Flow, LLC CRM instances can be
               purchased. The Forward Flow, LLC CRM includes features for
               capturing, tracking, managing, and nurturing Leads, managing
               agent activity, contacts, and workflows. Multiple Forward Flow,
               LLC's teamers are assigned individual access to a single instance
               of the Forward Flow, LLC CRM for the purpose of collaboration.
            </p>
            <p className="mb-3">4.2</p>
            <p className="mb-3">
               FORWARDFLOW REAL ESTATE WEBSITES. Forward Flow, LLC will provide
               the user with the number and type of Forward Flow, LLC Real
               Estate platforms that are defined in yForward Flow, LLC's
               Subscription Agreement with Forward Flow, LLC. Some Forward Flow,
               LLC packages do not include access to Forward Flow, LLC Forward
               Flow, LLC's organizationbsite features. Forward Flow, LLC Real
               Estate platforms include features for marketing to, registering,
               educating, and providing property information from enabled MLS
               providers to site visitors and Leads.
            </p>
            <p className="mb-3">
               IDX WEBSITES. Forward Flow, LLC offers IDX platforms that
               integrate with yForward Flow, LLC's MLS provider(s) to provide
               listing data feeds. You are solely responsible for maintaining
               all compliance standards. Forward Flow, LLC does not assume any
               responsibility for inappropriate Forward Flow, LLC's teame of a
               Forward Flow, LLC IDX platform. Users can be granted admin access
               to edit Forward Flow, LLC's organizationbsites owned by other
               Forward Flow, LLC's teamers within their organization.
            </p>
            <p className="mb-3">
               DOMAIN NAME. When building yForward Flow, LLC's real estate
               Forward Flow, LLC's organizationbsite on Forward Flow, LLC, the
               user can choose to Forward Flow, LLC's teame a domain name that
               the user already own or, alternatively, the user can choose to
               select a new domain available or purchased through Forward Flow,
               LLC. Certain domain options require an additional charge subject
               to Forward Flow, LLC’s then current fee structure. Forward Flow,
               LLC reserves the right to refForward Flow, LLC's teame the
               Forward Flow, LLC's teame of any domain name that Forward Flow,
               LLC determines in its discretion is inappropriate, illegal,
               offensive, or in violation of another party's rights. When
               configuring yForward Flow, LLC's Forward Flow, LLC's
               organizationbsite on Forward Flow, LLC, yForward Flow, LLC's
               Forward Flow, LLC's organizationbsite content may exist only
               temporarily on a Forward Flow, LLC-specific domain during initial
               setup stages.
            </p>
            <p className="mb-3">
               MLS IDX/VOW DATA INTEGRATIONS. Forward Flow, LLC will make
               reasonable efforts to integrate yForward Flow, LLC's Multiple
               Listing Service (MLS) IDX and/or VOW data feed(s) from yForward
               Flow, LLC's respective MLS Board(s) as disclosed during the
               Forward Flow, LLC's organizationbsite setup process and/or in
               writing to Forward Flow, LLC. Any changes to yForward Flow, LLC's
               MLS membership or brokerage mForward Flow, LLC's teamt be
               submitted in writing to Forward Flow, LLC. You will indemnify,
               defend, and hold Forward Flow, LLC harmless from any failure by
               the user to obtain or maintain the appropriate licenses for the
               MLS and/or IDX/VOW account to allow Forward Flow, LLC's teame by
               Forward Flow, LLC on the platform or, for any unauthorized
               Forward Flow, LLC's teame by the user or Forward Flow, LLC's
               teamers on yForward Flow, LLC's account of such MLS data or
               feeds.
            </p>
            <p className="mb-3">
               Depending on the MLS(s) connected to yForward Flow, LLC's Forward
               Flow, LLC real estate Forward Flow, LLC's organizationbsite, the
               user may be responsible to pay all third-party vendor set-up fees
               and monthly service fees charged by the MLS/IDX/VOW provider for
               Forward Flow, LLC to access and maintain MLS data on yForward
               Flow, LLC's Forward Flow, LLC Forward Flow, LLC's
               organizationbsite.
            </p>
            <p className="mb-3">
               You shall also pay directly all charges from the MLS data
               provider including costs associated with MLS integration, and
               other marketing costs associated with the service. In certain
               geographic areas, Forward Flow, LLC may, at its option, configure
               multiple unique MLS feeds into a single platform. Multiple MLS
               feeds are subject to additional charges as determined by Forward
               Flow, LLC. Forward Flow, LLC will not be liable in the event that
               the MLS application process is unsuccessful or exceeds the
               initial timeline established by Forward Flow, LLC.
            </p>
            <p className="mb-3">
               Forward Flow, LLC will not be liable in the event that the MLS
               application process is unsuccessful or exceeds the initial
               timeline established by Forward Flow, LLC.
            </p>
            <p className="mb-3">
               MANUAL LISTINGS. Certain configurations of Forward Flow, LLC Real
               Estate platforms support the ability to upload manual listings
               that are not provided by an MLS/IDX/VOW provider (“Manual
               Listings”). These can sometimes be referred to as “pocket
               listings.” You are advised to consult yForward Flow, LLC's legal
               resForward Flow, LLC'sces prior to publishing Manual Listings to
               yForward Flow, LLC's Forward Flow, LLC Real Estate platform to
               ensure that doing so does not conflict with yForward Flow, LLC's
               obligations with any memberships, associations, or legal entities
               that may prohibit their Forward Flow, LLC's teame. Forward Flow,
               LLC will not be held liable for the user publishing Manual
               Listings that are not permitted in any scenario.
            </p>
            <p className="mb-3">
               THIRD-PARTY DATA. In certain configurations within the offerings,
               Forward Flow, LLC Real Estate platforms display data for a
               geographic location designated in comprehensive plans,
               ordinances, or other local documents, commonly referred to as a
               neighborhood (collectively, a “Neighborhood,” or
               “Neighborhoods”). You acknowledge Neighborhoods are not subject
               to a generally accepted definition, but are subject to individual
               interpretation. Also, Neighborhoods as shown on the Member
               platform are not necessarily &quot;subdivisions&quot; and
               Neighborhoods are not available for every city in the U.S. You
               may find deviations betForward Flow, LLC's organizationen what is
               shown and what the user might personally expect. Neighborhood
               data may also be unavailable outside of the United States.
            </p>
            <p className="mb-3">
               You also acknowledge that data availability for certain aspects
               of pages on yForward Flow, LLC's Forward Flow, LLC Real Estate
               platform may vary depending on what is available from the
               third-party data sForward Flow, LLC'sce. Examples may include
               statistical data, pre-populated geographic descriptions and
               overviews, school data, and multiple other aspects of Forward
               Flow, LLC Real Estate platform Forward Flow, LLC's
               organizationbpages. This data is provided via third-party
               agreements and datasets and as such, the availability in some
               scenarios (location, dates, etc.) will vary.
            </p>
            <p className="mb-3">
               BRANDING AND CONTENT. You warrant that all Branding and Content
               that the user provide and/or implement on yForward Flow, LLC's
               Forward Flow, LLC real estate Forward Flow, LLC's
               organizationbsite will comply with all MLS rules and regulations
               and all applicable laws.
            </p>
            <p className="mb-3">
               WEBSITE CUSTOMIZATIONS. As part of the offerings, Forward Flow,
               LLC provides a cForward Flow, LLC's teamtom-built Content
               Management System (“CMS”) for the configuring of Forward Flow,
               LLC real estate Forward Flow, LLC's organizationbsites. Certain
               features allow for authorized Forward Flow, LLC's teamers to add
               cForward Flow, LLC's teamtom code to their Real Estate platform
               for the purpose of tracking, linking to other Forward Flow, LLC's
               organizationb services, or changing the visible design. You
               accept any risks related to the presentation, availability, or
               functionality of yForward Flow, LLC's real estate Forward Flow,
               LLC's organizationbsite associated with the addition of any
               cForward Flow, LLC's teamtom code by the user or any third party
               who the user have authorized to do so on yForward Flow, LLC's
               behalf.
            </p>
            <p className="mb-3">
               If, upon yForward Flow, LLC's approval, Forward Flow, LLC has
               added cForward Flow, LLC's teamtom code to yForward Flow, LLC's
               Forward Flow, LLC's organizationbsite, the user accept that any
               configurations made are done without warranty and can be affected
               by changes made via the CMS at a later point and may require
               adjForward Flow, LLC's teamting. New product releases published
               by Forward Flow, LLC within the offerings and related to yForward
               Flow, LLC's Forward Flow, LLC's organizationbsite may affect
               cForward Flow, LLC's teamtomizations that the user have
               implemented.
            </p>
            <p className="mb-3">4.3</p>
            <p className="mb-3">
               WEB, MOBILE, AND TABLET APPS. Forward Flow, LLC offerings can be
               accessed via desktop or laptop computers Forward Flow, LLC's
               teaming the Forward Flow, LLC Web App (Forward Flow, LLC's
               teaming a supported browser) or via mobile phone or tablet
               devices Forward Flow, LLC's teaming multiple native mobile and
               tablet apps available to download on Android and Apple app stores
               (collectively, “Supported Devices”). You acknowledge and
               understand that features available to utilize Forward Flow, LLC
               offerings will vary betForward Flow, LLC's organizationen
               Supported Devices and that not all features available on one
               device will always be available on another (e.g. tablet vs. cell
               phone phones).
            </p>
            <p className="mb-3">4.4</p>
            <p className="mb-3">
               FORWARDFLOW LENDER CRM. The Forward Flow, LLC Lender CRM (“Lender
               CRM”) is a version of Forward Flow, LLC’s offerings configured
               for the Forward Flow, LLC's teame by a mortgage lender as the
               intended Forward Flow, LLC's teamer. Lender CRM access can be
               established via the Platform but is not available to all
               packages. You understand that The Lender CRM is not the same as
               the Forward Flow, LLC CRM and therefore there will be
               functionality differences betForward Flow, LLC's organizationen
               them.
            </p>
            <p className="mb-3">4.5</p>
            <p className="mb-3">
               LOCATION. You accept that there may be limitations to
               functionality within provided offerings due to unavailable data
               or support for specific locations.
            </p>
            <p className="mb-3">4.6</p>
            <p className="mb-3">
               UPDATES AND EARLY ACCESS. Forward Flow, LLC reserves the right to
               update, modify, and upgrade the Platform and offerings in its
               sole discretion during the term of this Agreement. Such
               modifications or updates may include new or modified
               functionality or removal of functions.
            </p>
            <p className="mb-3">
               We may make certain features available to some Forward Flow,
               LLC's teamers before they are published to all Forward Flow,
               LLC's teamers (“Early Access Features”, “Beta Features”,
               “Whitelist Features”). Early Access Features are occasionally
               provided for the purpose of testing functionality, documenting
               feedback and engagement, and ensuring an ideal launch takes place
               for those features. Should the user request to participate or be
               selected directly by Forward Flow, LLC for Early Access Features,
               the user understand that Forward Flow, LLC reserves the right to
               update, modify, or remove access at any time. You also understand
               that when Forward Flow, LLC's teaming these features, the user
               may experience outages, unavailability, or system bugs and are
               encForward Flow, LLC'saged to report such cases to Forward Flow,
               LLC Support () for the improvement of said features. Forward
               Flow, LLC provides no warranty and will not be liable for the
               unavailability, loss of bForward Flow, LLC's teaminess, or other
               negative results due to the Forward Flow, LLC's teame of Early
               Access Features.
            </p>
            <p className="mb-3">4.7</p>
            <p className="mb-3">
               ADD-ON PRODUCTS AND SERVICES. Forward Flow, LLC offers optional
               add-on products and services that can be added to yForward Flow,
               LLC's Subscription (collectively, “Add-Ons”) directly via the
               Platform and in the Forward Flow, LLC Marketplace. These services
               will be added to yForward Flow, LLC's subscription only when
               included in the package the user are purchasing or when added via
               the Forward Flow, LLC Marketplace. These Add-Ons may require the
               payment of additional charges by the user in order to access
               their functions and features. You will be billed according to the
               terms of each product or service displayed to the user at the
               time of purchase.
            </p>
            <p className="mb-3">Forward Flow, LLC Marketing offerings</p>
            <p className="mb-3">
               Forward Flow, LLC offers optional lead generation marketing and
               management services that may be selected by the user. These
               marketing functions such as lead generation, Listing Blast and
               management services, etc. made available by Forward Flow, LLC on
               the Platform may require the payment of additional charges by the
               user. You will be billed accordingly in order for such
               functionality to be Forward Flow, LLC's teamed. The Lead(s)
               captured is/are the result of yForward Flow, LLC's paid campaigns
               that collected contact information for potential cForward Flow,
               LLC's teamtomer(s) who shoForward Flow, LLC's organizationd
               interest in buying, renting, or selling hoForward Flow, LLC's
               teames by engaging with the advertising campaigns that Forward
               Flow, LLC activated on yForward Flow, LLC's behalf. For lead
               generation, Forward Flow, LLC will create and develop yForward
               Flow, LLC's online advertising campaign on the Facebook Ads
               Platform, Google Ads Platform, and/or other marketing channels,
               help the user with yForward Flow, LLC's image/video design,
               generate keyword combinations, etc. for yForward Flow, LLC's
               Forward Flow, LLC's organizationbsite and listings, and curate
               specific ad copy based on yForward Flow, LLC's bForward Flow,
               LLC's teaminess and location. Forward Flow, LLC will also manage
               yForward Flow, LLC's online advertising campaign by assessing
               yForward Flow, LLC's ad position, audience, scheduling, bidding,
               etc.
            </p>
            <p className="mb-3">Types of Marketing</p>
            <p className="mb-3">
               LEAD GENERATION ADS. Lead generation digital marketing ad
               campaigns are configured and managed by the Forward Flow, LLC
               Digital Marketing Team on multiple search and social media
               platforms with the objective of capturing Lead(s) who have shown
               interest in the real estate market (“Lead Generation”).
            </p>
            <p className="mb-3">
               Listing Blast. The Listing Blast are self-purchased Facebook ads
               and are created by the user via yForward Flow, LLC's own CRM.
               These ads are designed to promote a real estate property within
               the real estate/hoForward Flow, LLC's teaming marketing category
               and are not designed to capture Lead(s) as a primary objective.
               Currently, Forward Flow, LLC’s Listing Blast are only available
               on Facebook while Instagram is available only by manual request.
            </p>
            <p className="mb-3">
               BOOST ADS. Forward Flow, LLC Social Studio Pro includes optional
               Boost Ads services that may be selected by the user to promote
               yForward Flow, LLC's Facebook post as a paid promotion.
            </p>
            <p className="mb-3">
               DIRECT MAIL SERVICES. Direct mail services are available for lead
               generation and marketing. Forward Flow, LLC may change the direct
               mail services offered at its sole discretion from time to time.
               Forward Flow, LLC may offer a la carte direct mail services and
               products that will be billed at Forward Flow, LLC's then current
               rates for such products and services. You will be responsible for
               any increase in the cost of postage by the United States Postal
               Service (the &quot;USPS&quot;) for direct mail services and the
               fees charged by Forward Flow, LLC for such services shall be
               adjForward Flow, LLC's teamted by the amount of any increase as
               of the effective date of the increase. You understand and
               acknowledge that there is an expected amount of
               &quot;kickback&quot; with direct mail services and that ten
               percent or more of the mailings may be undeliverable. Forward
               Flow, LLC shall have no responsibility for returns from the USPS
               and the user shall not be entitled to any refund or credit for
               returns. Direct Mail offerings are not available in Canada.
            </p>
            <p className="mb-3">Marketing Results</p>
            <p className="mb-3">
               You acknowledge that the Leads are not guaranteed to be qualified
               or engaged cForward Flow, LLC's teamtomers and the information
               that Forward Flow, LLC’s Marketing offerings collects is based on
               individual Forward Flow, LLC's teamer behavior and subject to
               collecting said information. We suggest the Members contact the
               leads as soon as possible to obtain the most effective results.
               Forward Flow, LLC shall not be responsible for any results
               arising therefrom, including (but not limited to) whether the
               user can turn the Lead into a valuable cForward Flow, LLC's
               teamtomer.
            </p>
            <p className="mb-3">Associated Marketing Platform Terms</p>
            <p className="mb-3">
               By purchasing and utilizing Forward Flow, LLC’s Marketing
               offerings on a specific advertising platform such as
               the&nbsp;,&nbsp;,&nbsp;,&nbsp;, and/or&nbsp;Tiktok Platform, the
               user acknowledge and accept the Terms of Service of the
               corresponding advertising platform provider(s).
            </p>
            <p className="mb-3">
               When utilizing Listing Blast directly to market yForward Flow,
               LLC's real estate listings or Boost Ads via the Forward Flow, LLC
               Platform on Facebook and related services, the user mForward
               Flow, LLC's teamt ensure that any images, videos, and/or other
               content for these ads are related to real estate and appropriate
               for all appropriate audiences. If the images, videos, and/or
               other content that the user upload are considered to be related
               to alcohol, adult content, and or anything not firmly considered
               to be part of the real estate/hoForward Flow, LLC's teaming
               category, they may be removed. Forward Flow, LLC reserves the
               right to (but is not responsible for) editing any posts that may
               not utilize images, video, and/or other content not appropriate
               to the platform providers’ terms for the real estate/hoForward
               Flow, LLC's teaming category.
            </p>
            <p className="mb-3">
               If the user promote the product(s) with the incorrect category
               that Facebook Ads Platforms disapproved for HoForward Flow, LLC's
               teaming, yForward Flow, LLC's ads might be edited or deleted by
               Forward Flow, LLC without yForward Flow, LLC's permission and the
               user will not be issued a refund.
            </p>
            <p className="mb-3">
               It is yForward Flow, LLC's responsibility to ensure that the user
               have the necessary permission to promote or create marketing
               material with listings from yForward Flow, LLC's MLS/VOW/IDX.
               Certain listing data organizations implement specific rules on
               what can and cannot be marketed. You understand that the user
               mForward Flow, LLC's teamt learn and abide by these rules prior
               to Forward Flow, LLC's teaming any marketing features within
               Forward Flow, LLC. Forward Flow, LLC will not be liable for the
               misForward Flow, LLC's teame of any listing data.
            </p>
            <p className="mb-3">Marketing Billing</p>
            <p className="mb-3">
               AD BUDGET AND MANAGEMENT FEES. You will provide a monetary
               advertising budget (&quot;Ad Budget&quot;), and hereby appoint
               and authorize Forward Flow, LLC as an agent to procure
               advertising on yForward Flow, LLC's behalf utilizing this Ad
               Budget. In addition to the Ad Budget, the user will pay Forward
               Flow, LLC a management fee (“Management Fee”) to be determined by
               Forward Flow, LLC based upon the type of marketing service and Ad
               Budget. Forward Flow, LLC reserves the right to raise or
               loForward Flow, LLC's organizationr the Management Fee at any
               time. Forward Flow, LLC will notify the user of such a change
               which will go into affect as of the next billing cycle. Minimum
               Ad Budget amounts may be required in order to run different types
               of Lead Generation campaigns and these amounts are subject to
               change at any time at the discretion of Forward Flow, LLC. The
               Management Fee and Ad Budget are both non-transferable and
               non-refundable.
            </p>
            <p className="mb-3">
               MARKETING SERVICES RENEWAL. Forward Flow, LLC renews yForward
               Flow, LLC's order on the first day of each month (“Billing
               Cycle”), and charges the user the Ad Budget and the Management
               Fee. You may change, paForward Flow, LLC's teame, or cancel the
               order before the next Billing Cycle by notifying Forward Flow,
               LLC Support or yForward Flow, LLC's Forward Flow, LLC Digital
               Marketing Analyst at least seven (7) bForward Flow, LLC's
               teaminess days prior to the next Billing Cycle. Otherwise,
               Forward Flow, LLC will continue to Forward Flow, LLC's teame the
               same settings to operate and optimize yForward Flow, LLC's
               advertising without further notice.
            </p>
            <p className="mb-3">
               PRORATION. In certain scenarios, Forward Flow, LLC will process
               yForward Flow, LLC's Billing Cycle Forward Flow, LLC's teaming a
               prorated billing method for the initial bill if starting a
               campaign in a month that has already begun. This is calculated by
               taking the total monthly Ad Budget, dividing it by the total days
               in the current month, and then multiplying this by the number of
               days remaining in the current month (“Proration”). By prorating,
               this will allow for a similar daily amount to be billed (and
               therefore utilized for advertising) within the current month
               Billing Cycle and future month Billing Cycles. Future billing
               will resume on the first of every month at the full amount and
               will not be prorated. The Management Fee will not be prorated and
               will always be billed at the amount defined in this Agreement.
            </p>
            <p className="mb-3">
               ADS OPERATING DURATION. For Lead Generation ads, Forward Flow,
               LLC offers ongoing subscription plans. If the user require a
               specific plan duration, the user may contact yForward Flow, LLC's
               Digital Marketing Analyst for professional advice and to
               discForward Flow, LLC's teams the details or the duration.
               Forward Flow, LLC will continue yForward Flow, LLC's subscription
               until the user request a change or to cancel, unless otherwise
               specified. When the user successfully subscribe to Lead
               Generation Ads, Forward Flow, LLC will assume that the user are
               aware of and accept the duration of ads as defined herein.
            </p>
            <p className="mb-3">
               CANCELLATION AND REFUNDS. When the user request that yForward
               Flow, LLC's Forward Flow, LLC Marketing offerings to be canceled,
               Forward Flow, LLC will not refund the remaining account budget
               nor stop yForward Flow, LLC's ads. Instead, the Ad Budget will be
               utilized to continue to run yForward Flow, LLC's ads until it is
               depleted. If the ad spending exceeds the budget subsequent to
               cancellation, the user will not be responsible for paying any
               overspending cost or the Management Fee related specifically to
               what was overspent.
            </p>
            <p className="mb-3">AI Assistant User Agreement</p>
            <p className="mb-3">
               By accessing and Forward Flow, LLC's teaming the Forward Flow,
               LLC AI Assistant (“AI Assistant”), the user understand and agree
               to all related terms and conditions outlined below and in related
               parts of this entire Agreement.
            </p>
            <p className="mb-3">
               Free Trial. On certain occasions, Forward Flow, LLC will offer
               the AI Assistant to be available to Forward Flow, LLC's teamers
               on a free trial basis. The duration of the free trial will be
               specified upon initiating its functionality for yForward Flow,
               LLC's account. YForward Flow, LLC's continued Forward Flow, LLC's
               teame of the AI Assistant upon completion of the free trial
               indicates yForward Flow, LLC's approval to process recurring
               billing for the following billing dates.
            </p>
            <p className="mb-3">
               The AI Assistant will be available in different packages (“AI
               Packages”) whose functionality will vary depending on the option
               selected and purchased.
            </p>
            <p className="mb-3">Call and Text Packages</p>
            <p className="mb-3">Revised Version:</p>
            <p className="mb-3">
               Forward Flow, LLC Call and Text offerings Information
            </p>
            <p className="mb-3">General Policy</p>
            <p className="mb-3">
               Forward Flow, LLC services will incur charges for all calls,
               texts, group texts, MMS, and other related services. Users
               mForward Flow, LLC's teamt maintain a minimum credit of $50, with
               automatic reloads triggered when the balance reaches a designated
               threshold. Detailed pricing information is available on Forward
               Flow, LLC’s pricing sheet. No bundled call or text packages are
               offered; all Forward Flow, LLC's teamage is billed as per the
               platform’s standard rates.
            </p>
            <p className="mb-3">Updated Package and Service Policies</p>
            <p className="mb-3">a. Call and Text Usage</p>
            <p className="mb-3">
               • Forward Flow, LLC offers a pay-as-the user-go model for calls
               and texts. Specific features may have associated costs or
               limitations based on their technical requirements. Billing is
               based on call duration and the number of texts sent, as outlined
               in the pricing sheet.
            </p>
            <p className="mb-3">
               • No predefined call or text packages are available. Users are
               charged for Forward Flow, LLC's teamage according to the
               applicable rates.
            </p>
            <p className="mb-3">b. Account-Level Usage Tracking</p>
            <p className="mb-3">
               • Account owners, designated admins, and team members can monitor
               Forward Flow, LLC's teamage within the platform. Monthly reports
               summarize the total number of calls and texts processed.
            </p>
            <p className="mb-3">
               • If a detailed statement is required or if the user need
               assistance with upgrading or modifying services, contact Forward
               Flow, LLC Support at support@forward-flow.com.
            </p>
            <p className="mb-3">c. Virtual Numbers</p>
            <p className="mb-3">
               • A virtual number is required for call and text services.
               Forward Flow, LLC offers virtual numbers for personal Forward
               Flow, LLC's teame (“Personal Virtual Number”) or shared account
               Forward Flow, LLC's teame (“Company Virtual Number”), with
               additional monthly fees as applicable.
            </p>
            <p className="mb-3">
               • To port an existing number, contact Forward Flow, LLC Support.
               While Forward Flow, LLC will make reasonable efforts to
               facilitate porting, timelines and outcomes are not guaranteed.
            </p>
            <p className="mb-3">d. Usage Limitations</p>
            <p className="mb-3">
               • Usage limits are in place to ensure compliance with telecom
               standards and prevent virtual numbers from being flagged as spam
               or fraudulent.
            </p>
            <p className="mb-3">
               • Unlimited call or text plans, where available, may incur
               overage fees, as outlined in the pricing details. Users are
               responsible for ensuring their Forward Flow, LLC's teamage
               adheres to platform guidelines to avoid additional costs or
               potential disruptions.
            </p>
            <p className="mb-3">e. Transmission and Delivery Standards</p>
            <p className="mb-3">
               • Forward Flow, LLC utilizes Call/Text Vendors to route
               communications through major telecom networks. While Forward
               Flow, LLC ensures prompt routing to the network, final delivery
               depends on the carriers and network constraints, and delivery
               times cannot be guaranteed.
            </p>
            <p className="mb-3">
               • Communications that cannot be delivered within their designated
               “lifetime” may be discarded by carriers without notice. Forward
               Flow, LLC assumes no liability for undelivered communications or
               related damages.
            </p>
            <p className="mb-3">
               f. MisForward Flow, LLC's teame and Termination
            </p>
            <p className="mb-3">
               • Forward Flow, LLC reserves the right to terminate services
               immediately if misForward Flow, LLC's teame, including fraudulent
               activity, is sForward Flow, LLC's teampected. In such cases,
               Forward Flow, LLC may notify relevant law enforcement agencies,
               Call/Text Vendors, or other parties as necessary.
            </p>
            <p className="mb-3">
               • offerings may also be terminated without caForward Flow, LLC's
               teame upon 30 days’ notice. Forward Flow, LLC is not liable for
               damages resulting from termination or discontinuation of
               services.
            </p>
            <p className="mb-3">g. Compliance Obligations</p>
            <p className="mb-3">
               • Users mForward Flow, LLC's teamt comply with all applicable
               laws, including but not limited to the Telephone Consumer
               Protection Act (TCPA), Telemarketing Sales Rule, and CAN-SPAM
               Act.
            </p>
            <p className="mb-3">
               • Non-compliance may result in substantial fines, for which
               Forward Flow, LLC assumes no liability. Legal compliance is the
               sole responsibility of the Forward Flow, LLC's teamer. Telecom
               regulations evolve; consult a legal expert or compliance provider
               for guidance.
            </p>
            <p className="mb-3">
               This streamlined document emphasizes Forward Flow, LLC’s
               pay-as-the user-go model, eliminates mention of bundled packages,
               and maintains clarity on compliance, termination rights, and
               Forward Flow, LLC's teamage responsibilities. Let me know if
               additional changes are required!
            </p>
            <p className="mb-3">
               RESPONSIBLE USE. You agree to abide by the following responsible
               Forward Flow, LLC's teame requirements in connection with
               yForward Flow, LLC's access to and Forward Flow, LLC's teame of
               any call package or text package licensed within the Forward
               Flow, LLC platform or Forward Flow, LLC Marketplace:
            </p>
            <p className="mb-3">
               You shall familiarize yForward Flow, LLC'sself with all laws,
               rules, and regulations governing yForward Flow, LLC's calling and
               texting.
            </p>
            <p className="mb-3">
               You shall follow all laws, rules, and regulations governing
               yForward Flow, LLC's calling or texting.
            </p>
            <p className="mb-3">
               You shall provide legal contact information in any outbound
               campaign within the initial greeting message and, if the calls
               are monitored or recorded, to provide adequate notification
               within the initial greeting message.
            </p>
            <p className="mb-3">
               You shall provide yForward Flow, LLC's own sound files for all
               outbound campaigns.
            </p>
            <p className="mb-3">
               You shall responsibly dial each campaign with cForward Flow,
               LLC'stesy and in compliance with all applicable laws, rules and
               regulations.
            </p>
            <p className="mb-3">
               You shall not send any calls to life-line services, such as
               hospitals, fire, police, 911, or utility related telephone
               numbers.
            </p>
            <p className="mb-3">
               You shall not send any sales outbound broadcasts to recipients
               that have not consented to receiving such a broadcast.
            </p>
            <p className="mb-3">
               You shall Forward Flow, LLC's teame opt-out features made
               available to the user via Forward Flow, LLC.
            </p>
            <p className="mb-3">Training and Coaching Programs</p>
            <p className="mb-3">
               By accessing training or coaching content provided by Forward
               Flow, LLC and made available to enroll in such programs via the
               Forward Flow, LLC Marketplace (collectively, “Premium
               Coaching/Training”), the user agree to not sublicense or
               otherwise distribute access or content from this Premium
               Coaching/Training.
            </p>
            <p className="mb-3">4.8</p>
            <p className="mb-3">
               AI-GENERATED CONTENT. If available in yForward Flow, LLC's access
               to offerings, AI-generated content mForward Flow, LLC's teamt be
               Forward Flow, LLC's teamed according to the following terms:
            </p>
            <p className="mb-3">
               Accuracy and Compliance: The accuracy and reliability of the
               generated content cannot be guaranteed. Users are responsible for
               verifying the accuracy of the generated materials and ensuring
               compliance with applicable laws, regulations, and indForward
               Flow, LLC's teamtry standards.
            </p>
            <p className="mb-3">
               User Conduct: Users shall not Forward Flow, LLC's teame the
               feature to generate content that infringes upon the rights of
               others, including intellectual property rights, privacy rights,
               or defamatory content. Any such Forward Flow, LLC's teame may
               result in termination of Forward Flow, LLC's teamer access.
            </p>
            <p className="mb-3">
               Data Privacy: User data collected during the Forward Flow, LLC's
               teame of the feature is subject to Forward Flow, LLC's privacy
               policy, which outlines how Forward Flow, LLC's organization
               handle and protect Forward Flow, LLC's teamer data. By Forward
               Flow, LLC's teaming the feature, Forward Flow, LLC's teamers
               consent to the collection, Forward Flow, LLC's teame, and sharing
               of their data in accordance with Forward Flow, LLC's privacy
               policy.
            </p>
            <p className="mb-3">
               Disclaimer of Liability: Forward Flow, LLC shall not be liable
               for any damages or losses arising from the Forward Flow, LLC's
               teame of the generated content. Users assume all risks associated
               with their Forward Flow, LLC's teame of the feature.
            </p>
            <p className="mb-3">
               Termination and Modification: Forward Flow, LLC reserves the
               right to modify or terminate the feature at any time, without
               prior notice. In the event of termination, Forward Flow, LLC's
               teamer access to the feature may be discontinued. Refunds, if
               applicable, will be governed by Forward Flow, LLC's refund
               policy.
            </p>
            <p className="mb-3">5. Support offerings</p>
            <p className="mb-3">
               All Forward Flow, LLC clients will have access to contact the
               Forward Flow, LLC Support Team via phone (1-719-639-3932), email
               (), and chat (only available via the Forward Flow, LLC's
               organizationb app platform). Users will also have access to
               Forward Flow, LLC’s Help Center, videos, and Forward Flow, LLC's
               teamer guides. Forward Flow, LLC may change the support services
               offered at its sole discretion from time to time and may offer
               certain support/training services at additional fees.
            </p>
            <p className="mb-3">6. Payment and Fees</p>
            <p className="mb-3">
               The Forward Flow, LLC's teame of certain offerings may be subject
               to payment of particular fees, as determined by Forward Flow,
               LLC's team in Forward Flow, LLC's sole discretion
               (&quot;Fees&quot;). We will provide notice of such Fees then in
               effect in relation to such offerings prior to charging any amount
               to yForward Flow, LLC's payment method on file. If the user wish
               to receive or Forward Flow, LLC's teame such offerings, the user
               are required to pay all applicable Fees in advance or, as
               required by specific offerings, in arrears. We reserve the right
               to change Forward Flow, LLC's Fees at any time, upon notice to
               the user if such change may affect yForward Flow, LLC's existing
               subscriptions, except where a term agreement has been made
               betForward Flow, LLC's organizationen the user and Forward Flow,
               LLC.
            </p>
            <p className="mb-3">6.1</p>
            <p className="mb-3">
               CURRENCY. All Fees are in U.S. Dollars, except as specifically
               stated otherwise in writing by Forward Flow, LLC's team. All Fees
               shall be paid in U.S. Dollars.
            </p>
            <p className="mb-3">6.2</p>
            <p className="mb-3">
               TAXES. To the extent permitted by law (and unless specified
               otherwise by Forward Flow, LLC's team in writing), all Fees are
               exclForward Flow, LLC's teamive of all taxes (including value
               added tax, sales tax, goods and services tax, etc.), levies or
               duties imposed by taxing authorities (&quot;Taxes&quot;), and the
               user shall be responsible for payment of all applicable Taxes
               relating to yForward Flow, LLC's Forward Flow, LLC's teame of the
               offerings, or to any payments or purchases made by the user. If
               Forward Flow, LLC's organization are obligated to collect or pay
               Taxes for the Fees payable by the user, and whether or not such
               Taxes Forward Flow, LLC's organizationre added and collected from
               the user for previoForward Flow, LLC's team transactions, such
               Taxes may be added to the payment of any outstanding Fees and
               will be reflected in the Invoice for such transaction.
            </p>
            <p className="mb-3">6.3</p>
            <p className="mb-3">
               ACCOUNT ACTIVATION FEE. An “Account Activation Fee” is due at the
               time of account setup and is non-refundable. This fee is Forward
               Flow, LLC's teamed to cover a variety of services including (but
               not limited to) account setup and creation, training and help
               resForward Flow, LLC'sces, and support.
            </p>
            <p className="mb-3">6.4</p>
            <p className="mb-3">
               MLS FEE. When not already included in yForward Flow, LLC's
               platform fee, the user as the client may be responsible to pay an
               “MLS Fee” to Forward Flow, LLC Forward Flow, LLC's teamed for
               managing MLS documentation, processing applications, and cover
               MLS vendor fees. Multiple MLS feeds are subject to additional
               charges as determined by Forward Flow, LLC at the then current
               pricing structure and as communicated to the user at the time of
               addition.
            </p>
            <p className="mb-3">6.5</p>
            <p className="mb-3">
               CONTRACT DURATION. You hereby agree to abide by the duration of
               the contract stated in yForward Flow, LLC's Subscription
               Agreement. Renewal and Cancellation policies are outlined
               separately below.
            </p>
            <p className="mb-3">6.6</p>
            <p className="mb-3">
               PAYMENT COLLECTIONS. As part of registering or submitting
               information to receive offerings, the user also authorize Forward
               Flow, LLC's team (either directly or through Forward Flow, LLC's
               affiliates, subsidiaries, or other third parties) to request and
               collect payment (or otherwise charge, refund, or take any other
               billing actions) from Forward Flow, LLC's payment provider or
               yForward Flow, LLC's designated banking account, and to make any
               inquiries Forward Flow, LLC's organization or Forward Flow, LLC's
               subsidiaries or affiliates may consider necessary to validate
               yForward Flow, LLC's designated payment account or financial
               information, in order to ensure prompt payment, including for the
               purpose of receiving updated payment details from yForward Flow,
               LLC's payment, credit card or banking account provider (e.g.,
               updated expiry date or card number as may be provided to Forward
               Flow, LLC's team by yForward Flow, LLC's credit card company).
               When the user receive a charge on yForward Flow, LLC's payment
               method for yForward Flow, LLC's Forward Flow, LLC Subscription,
               it will show as being from Forward Flow, LLC Inc.
            </p>
            <p className="mb-3">6.7</p>
            <p className="mb-3">
               INVOICING. Should the user require an invoice or credit memo,
               Forward Flow, LLC's organization and/or Forward Flow, LLC's
               subsidiary or affiliated companies can assist the user by issuing
               an Invoice for any payment of Fees or refund made to or by
               Forward Flow, LLC's team (&quot;Invoice&quot;). Each Invoice will
               be issued in electronic form and based on the country stated in
               yForward Flow, LLC's billing address and will be made available
               to the user via yForward Flow, LLC's Member Account and/or by
               email. For the purpose of issuing the Invoice, the user may be
               required to furnish certain personal information in order to
               comply with local laws. Please note that the Invoice presented in
               yForward Flow, LLC's Member Account may be inadequate with
               yForward Flow, LLC's local law requirements, and in such case,
               may be Forward Flow, LLC's teamed for pro forma purposes only.
            </p>
            <p className="mb-3">6.8</p>
            <p className="mb-3">
               AUTOMATIC RENEWAL. To ensure that the user do not experience any
               interruption or loss of services due to the lapse of any
               particular subscription period, the offerings operate with
               automatic renewal, on a recurring-fees basis (except where
               explicitly stated otherwise by Forward Flow, LLC's team in
               writing). We will automatically renew the applicable offerings
               according to the scenario listed here based on yForward Flow,
               LLC's Subscription Agreement type which will be one of the
               following:
            </p>
            <p className="mb-3">
               Monthly Agreement. YForward Flow, LLC's offerings will be
               automatically reneForward Flow, LLC's organizationd for another
               calendar month after the current month has ended. You will be
               automatically charged the applicable Fees Forward Flow, LLC's
               teaming the payment method the user have on file with Forward
               Flow, LLC's team. At the end of each term, this Agreement shall
               automatically renew unless terminated by either party in writing
               before the next Billing Cycle prior to the expiration of the
               then-current term.
            </p>
            <p className="mb-3">
               Contract Agreement. Regardless of the initial contract duration,
               yForward Flow, LLC's offerings will be auto-reneForward Flow,
               LLC's organizationd for a one-year period at 12:00.01 a.m. on the
               day after the contract end date unless terminated by either party
               in writing at least ninety (90) calendar days prior to the
               contract end date.
            </p>
            <p className="mb-3">
               You will be automatically charged the applicable Fees Forward
               Flow, LLC's teaming the payment method the user have on file with
               Forward Flow, LLC's team. At the end of each term, this Agreement
               shall automatically renew unless terminated by either party in
               writing before the next Billing Cycle prior to the expiration of
               the then-current term. If the user received a discount or other
               promotional offer, Forward Flow, LLC's organization shall have
               the right to automatically and without notice renew yForward
               Flow, LLC's subscription to such offerings at the full applicable
               Fee.
            </p>
            <p className="mb-3">
               Notwithstanding anything to the contrary in the foregoing, the
               user are and shall be solely responsible for verifying and
               ensuring the successful renewal of the offerings the user Forward
               Flow, LLC's teame (whether or not such offerings are subject to
               automatic subscription renewals).
            </p>
            <p className="mb-3">6.9</p>
            <p className="mb-3">LATE OR UNSUCCESSFUL PAYMENTS.</p>
            <p className="mb-3">
               In the event of a failed payment, Forward Flow, LLC's
               organization may Forward Flow, LLC's teame automated
               communication tools, including AI-poForward Flow, LLC's
               organizationred calls, text messages, and emails, to notify the
               user and attempt to resolve the issue. These communications are
               intended to provide timely reminders, offer assistance in
               resolving payment failures, and facilitate the collection of
               overdue amounts.
            </p>
            <p className="mb-3">
               By Forward Flow, LLC's teaming Forward Flow, LLC's services, the
               user acknowledge and consent to the Forward Flow, LLC's teame of
               these automated tools for the purpose of addressing failed
               payments.
            </p>
            <p className="mb-3">6.10</p>
            <p className="mb-3">
               CANCELLATION AND FAILURE TO COMPLY. Failure to comply with any
               material term of this Agreement or failure to pay any Fee when
               due under this Agreement may result in sForward Flow, LLC's
               teampension of access (until full payment is made) or
               cancellation of yForward Flow, LLC's Member Account (or certain
               features thereof) and the provision of any related offerings or
               Third Party offerings to the user.
            </p>
            <p className="mb-3">
               You may discontinue Forward Flow, LLC's teame and request to
               cancel yForward Flow, LLC's Member Account or any offerings at
               any time by contacting the Forward Flow, LLC Support Team (). You
               shall be solely responsible for the discontinuation of any
               offerings purchased by the user. Purchased offerings, including
               those purchase on or through the offerings and Add-Ons, are
               non-refundable. There will be no refunds or credits for Account
               Activation Fees, partial months of service,
               upgrading/downgrading, or unForward Flow, LLC's teamed months.
               You may cancel yForward Flow, LLC's Account and offerings
               according to the terms that correspond to the contract length
               agreed upon in yForward Flow, LLC's Subscription Agreement. These
               terms are as follows:
            </p>
            <p className="mb-3">
               Monthly Agreement. You may request to cancel at any time. You
               will be billed one more full monthly fee prior to Cancellation
               and then yForward Flow, LLC's account and the accounts of any
               other Forward Flow, LLC's teamers on it will be scheduled for
               deactivation on the last day of the month following the current
               month regardless of when Cancelled.
            </p>
            <p className="mb-3">
               Contract Agreement. When canceling an agreement with a defined
               contract duration, the user will be required to pay the remaining
               contract value upon cancellation. If fees Forward Flow, LLC's
               organizationre paid in advance (prepaid) in accordance with a
               contract, no refunds will be made available by Forward Flow, LLC.
               Such Contract Agreement may be terminated by either party without
               caForward Flow, LLC's teame when written notice is provided at
               least ninety (90) calendar days prior to the contract end date.
            </p>
            <p className="mb-3">
               You shall be solely responsible with respect to the
               discontinuation of any offerings previoForward Flow, LLC's teamly
               purchased by the user, including due to a cancellation, failure
               to pay the applicable recurring Fees including due to failure of
               yForward Flow, LLC's payment method on file to accept the
               recurring charge, or due to any offerings not being subject to
               automatic subscription renewals. You acknowledge and agree that
               the user shall not have any claims against Forward Flow, LLC's
               team in relation to the discontinuation of any offerings or Third
               Party offerings, for whatever reason.
            </p>
            <p className="mb-3">6.11</p>
            <p className="mb-3">
               CHARGEBACKS. If, at any time, the user contact yForward Flow,
               LLC's bank or credit card company and decline, chargeback or
               otherwise reject the charge of any payable Fees (collectively, a
               &quot;Chargeback&quot;), this will constitute a breach of
               yForward Flow, LLC's payment obligations hereunder, yForward
               Flow, LLC's Forward Flow, LLC's teame of the offerings may be
               automatically terminated, yForward Flow, LLC's Member Account may
               be blocked and any data contained in such Member Account may be
               subject to cancellation and Capacity Loss (as defined in this
               Agreement). If the user have any questions or concerns regarding
               a payment made to Forward Flow, LLC's team, Forward Flow, LLC's
               organization encForward Flow, LLC'sage the user to first contact
               Forward Flow, LLC's Support Team at&nbsp;&nbsp;before filing a
               Chargeback with yForward Flow, LLC's financial institution.
            </p>
            <p className="mb-3">6.12</p>
            <p className="mb-3">
               SERVICE PROVIDER PAYMENT. You acknowledge and agree that Forward
               Flow, LLC may, as an accommodation and convenience to the user,
               accept payment of the charges provided for herein from yForward
               Flow, LLC's mortgage lender(s) or other service provider(s) (each
               a “Service Provider”). Notwithstanding such accommodation, the
               user expressly agree that the user shall remain solely liable for
               prompt payment of all charges and expenses and that Forward Flow,
               LLC shall have the right to cease providing such accommodation
               and to bill the user directly at any time upon prior notice. You
               are solely responsible for enlisting the services of a Service
               Provider and for all Forward Flow, LLC's teame of the Platform by
               such Service Provider under yForward Flow, LLC's account. You
               represent and warrant that the user and any such Service Provider
               shall be in compliance and shall continue to comply with all
               applicable laws related to yForward Flow, LLC's payment and
               shared services arrangement with the Service Provider. Forward
               Flow, LLC shall have no liability for any and all arrangements
               betForward Flow, LLC's organizationen the user and the Service
               Provider which impact the progress or results of Forward Flow,
               LLC’s services to the user. Forward Flow, LLC shall have no
               responsibility for any agreements, arrangements, or liabilities
               that occur betForward Flow, LLC's organizationen the user and the
               Service Provider.
            </p>
            <p className="mb-3">
               Should Forward Flow, LLC fail to receive payment from the Service
               Provider, the user will pay the full amount due. Both the user
               and the Service Provider will be notified via email. You will be
               able to re-invite the Service Provider and the Service Provider
               will not be charged for the previoForward Flow, LLC's team
               payment failure. Upon the Service Provider’s confirmation and
               receipt of updated payment information, the Service Provider’s
               next payment will be charged when the user are next billed by
               Forward Flow, LLC.
            </p>
            <p className="mb-3">
               The agreed percentage cost allocation the user and the Service
               Provider mForward Flow, LLC's teamt be in accordance with all
               applicable laws and regulations including any relevant
               obligations that might apply to either the user or the Service
               Provider. Note that for Section 8 of the Real Estate Settlement
               Procedures Act, 12 USC § 2607, (“RESPA”), compliance by the user
               and the Service Provider regarding a cost allocation percentage
               should be based upon relative benefits and value to be received
               by each party from the Service during co-marketing.
            </p>
            <p className="mb-3">6.13</p>
            <p className="mb-3">
               CHARGES FOR NEW FEATURES. Features of the Forward Flow, LLC CRM
               and Forward Flow, LLC Real Estate platform and other offerings
               may change from time to time and Forward Flow, LLC reserves the
               right to charge for new features that may be included in future
               CRM releases. We may change, sForward Flow, LLC's teampend, or
               terminate any of the offerings (or any features thereof, or
               prices thereof), at any time and in any manner. Such changes may
               become effective upon notice to the user (and in any event, not
               in a retroactive manner - except as required otherwise by law).
               If any such changes involve the payment of additional Fees,
               Forward Flow, LLC's organization will provide the user with a
               notice of such Fees prior to enabling such specific changes. If
               the user fail or refForward Flow, LLC's teame to pay such Fees,
               Forward Flow, LLC's organization may cancel yForward Flow, LLC's
               Member Account, continue to support yForward Flow, LLC's
               then-current offerings without enabling such changes, or provide
               the user with alternative offerings.
            </p>
            <p className="mb-3">6.14</p>
            <p className="mb-3">
               PAYMENT FOR TECH RESOURCES. In certain scenarios, and only with
               prior written agreement by both the user and Forward Flow, LLC,
               Forward Flow, LLC may commit to developing temporary technology
               solutions (“Manual Tech Solutions”) to address yForward Flow,
               LLC's individual requests to perform actions such as transfer or
               copy Forward Flow, LLC's organizationbsite content, apply mass
               actions to records within the offerings, or accomplish other
               miscellaneoForward Flow, LLC's team tasks as needs may arise.
               These scenarios are reated as individual requests and addressed
               on a case-by-case basis. Forward Flow, LLC reservers the right to
               (a) deny requests regardless of the circumstances, (b) charge a
               cForward Flow, LLC's teamtimization fee to the user for building
               and implementing a one-off solution, and (c) provide and
               adjForward Flow, LLC's teamt timelines for any agreed-upon work
               based on resForward Flow, LLC'sce availability.
            </p>
            <p className="mb-3">7. Content and Ownership</p>
            <p className="mb-3">7.1</p>
            <p className="mb-3">
               You represent and warrant that the user own all rights in and to
               any content provided by the user, including any designs, images,
               animations, videos, audio files, fonts, logos, illForward Flow,
               LLC's teamtrations, compositions, artworks, interfaces, text,
               literary works, listing/rental/sales information, and any other
               materials (&quot;Content,” and for such Content provided by the
               user, “Member Content”), or otherwise have (and will continue to
               have) the full poForward Flow, LLC's organizationr, title,
               licenses, consents and authority, in and to the Member Content,
               as necessary to legally Forward Flow, LLC's teame, publish,
               transfer, or license any and all rights and interests in and to
               such Member Content, whether publicly posted or privately
               transmitted.
            </p>
            <p className="mb-3">
               The following standards apply to any and all Member Content. You
               mForward Flow, LLC's teamt ensure that all Member Content posted
               by the user complies with all applicable laws and regulations.
               Without limiting the foregoing, the user mForward Flow, LLC's
               teamt not post Member Content that:
            </p>
            <p className="mb-3">
               infringes any patent, trademark, trade secret, copyright, right
               of publicity, or other right of any other person or entity or
               violates any law or contractual duty;
            </p>
            <p className="mb-3">the user know or reasonably believe</p>
            <p className="mb-3">
               is false, misleading, untruthful, or inaccurate;
            </p>
            <p className="mb-3">
               is unlawful, threatening, discriminatory, hateful, abForward
               Flow, LLC's teamive, harassing, defamatory, libeloForward Flow,
               LLC's team, deceptive, fraudulent, invasive of another’s privacy,
               tortioForward Flow, LLC's team, obscene, vulgar, pornographic,
               offensive, or profane;
            </p>
            <p className="mb-3">
               contains or depicts nudity or sexual activity;
            </p>
            <p className="mb-3">
               promotes bigotry, racism, hatred, or harm against any individual
               or group; or is
            </p>
            <p className="mb-3">
               otherwise inappropriate as determined by Forward Flow, LLC's team
               in Forward Flow, LLC's sole discretion;
            </p>
            <p className="mb-3">
               contains software virForward Flow, LLC's teames or any other
               disabling computer codes, files, or programs that are designed or
               intended to disrupt, damage, limit, or interfere with the proper
               function of any software, hardware, or telecommunications
               equipment, or to damage or obtain unauthorized access to any
               system, data, password, or other information of Forward Flow,
               LLC'ss or of any third party;
            </p>
            <p className="mb-3">
               impersonates, bullies, stalks, or intimidates any person or
               entity, including any of Forward Flow, LLC's employees or
               representatives, or falsifies or misrepresents yForward Flow,
               LLC'sself or yForward Flow, LLC's personal information; or
            </p>
            <p className="mb-3">
               includes any confidential information, violates the rights of
               others (including, without limitation, the rights of publicity
               and privacy and rights under a contract), or otherwise contains
               any material that could give rise to any civil or criminal
               liability under applicable laws or regulations, or that otherwise
               may be in conflict with these User Agreement.
            </p>
            <p className="mb-3">7.2</p>
            <p className="mb-3">
               MEMBER CONTENT LICENSE GRANT. As betForward Flow, LLC's
               organizationen Forward Flow, LLC's team and the user, the user
               shall own all intellectual property pertaining to yForward Flow,
               LLC's Member Content.
            </p>
            <p className="mb-3">
               By submitting Member Content through the offerings, the user
               hereby do and shall grant Forward Flow, LLC's team a worldwide,
               non-exclForward Flow, LLC's teamive, perpetual, royalty-free,
               fully paid, sublicensable, and transferable license to Forward
               Flow, LLC's teame, edit, modify, truncate, aggregate, reproduce,
               distribute, prepare derivative works of, display, perform, and
               otherwise fully exploit the Member Content in connection with the
               offerings and Forward Flow, LLC's (including successors’ and
               assigns’) bForward Flow, LLC's teaminesses, including, without
               limitation, for promoting and redistributing part or all of the
               offerings (and derivative works thereof) in any media formats and
               through any media channels (including, without limitation, third
               party Forward Flow, LLC's organizationbsites and feeds), and
               including after yForward Flow, LLC's termination of yForward
               Flow, LLC's Account or the offerings. You also hereby do and
               shall grant each Forward Flow, LLC's teamer of the offerings a
               non-exclForward Flow, LLC's teamive, perpetual license to access
               yForward Flow, LLC's Member Content through the offerings. For
               clarity, the foregoing license grants to Forward Flow, LLC's team
               and Forward Flow, LLC's Forward Flow, LLC's teamers do not affect
               yForward Flow, LLC's other ownership or license rights in
               yForward Flow, LLC's Member Content, including the right to grant
               additional licenses to yForward Flow, LLC's Member Content,
               unless otherwise agreed in writing. You represent and warrant
               that the user have all rights to grant such licenses to Forward
               Flow, LLC's team without infringement or violation of any third
               party rights, including, without limitation, any privacy rights,
               publicity rights, copyrights, trademarks, contract rights, or any
               other intellectual property or proprietary rights.
            </p>
            <p className="mb-3">7.3</p>
            <p className="mb-3">
               INTELLECTUAL PROPERTY RIGHTS. You acknowledge and agree that all
               right, title, and interest in and to the offerings, including any
               and all copyrightable materials or any other content thereof
               which is or may be subject to any intellectual property rights
               under any applicable law (including any artwork, graphics,
               images, Forward Flow, LLC's organizationbsite templates and
               widgets, literary work, sForward Flow, LLC'sce and object code,
               computer code (including html), applications, audio, mForward
               Flow, LLC's teamic, video and other media, designs, animations,
               interfaces, the &quot;look and feel&quot; of the offerings,
               methods, products, algorithms, data, interactive features and
               objects, advertising and acquisition tools and methods,
               inventions, trade secrets, logos, domains, cForward Flow, LLC's
               teamtomized URLs, trademarks, service marks, trade names and
               other proprietary identifiers, whether or not registered and/or
               capable of being registered (collectively, &quot;Intellectual
               Property&quot;), and any derivations thereof, are owned by or
               licensed to Forward Flow, LLC's team.
            </p>
            <p className="mb-3">7.4</p>
            <p className="mb-3">
               The names, logos, product and service names, designs, slogans,
               and other trademarks associated with the offerings are Forward
               Flow, LLC'ss and those of Forward Flow, LLC's licensors. You
               mForward Flow, LLC's teamt not Forward Flow, LLC's teame any of
               the foregoing without Forward Flow, LLC's written permission
               prior to Forward Flow, LLC's teame. All other names, logos,
               product and service names, designs, slogans, and other trademarks
               Forward Flow, LLC's teamed in connection with the offerings are
               the trademarks of their respective owners.
            </p>
            <p className="mb-3">7.5</p>
            <p className="mb-3">
               COPYRIGHTS. The offerings may contain Content specifically
               provided by Forward Flow, LLC's team, Forward Flow, LLC's
               partners, or Forward Flow, LLC's Forward Flow, LLC's teamers, and
               such Content is protected by copyrights, trademarks, service
               marks, patents, trade secrets, or other proprietary rights and
               laws. You shall abide by and maintain all copyright notices,
               information, and restrictions contained in any Content accessed
               through the offerings.
            </p>
            <p className="mb-3">7.6</p>
            <p className="mb-3">
               Subject to yForward Flow, LLC's full compliance with this
               Agreement and timely payment of all applicable Fees, Forward
               Flow, LLC's organization hereby grant the user, upon creating
               yForward Flow, LLC's Member Account and for as long as Forward
               Flow, LLC's organization provide the user with the offerings, a
               non-exclForward Flow, LLC's teamive, non-transferable,
               non-sub-licensable, fully revocable, limited license to Forward
               Flow, LLC's teame the offerings and Licensed Content, for the
               purpose of accessing and Forward Flow, LLC's teaming the
               offerings and generating and displaying yForward Flow, LLC's
               Member platform, solely as expressly permitted under the terms of
               this Agreement, and solely within the offerings. Any Forward
               Flow, LLC's teame of the offerings not expressly permitted by
               these User Agreement is a breach of these User Agreement and may
               violate copyright, trademark, or other laws.
            </p>
            <p className="mb-3">7.7</p>
            <p className="mb-3">
               LEAD OWNERSHIP. All Lead data belongs to the user as the Forward
               Flow, LLC's teamer and will not be shared with or be accessible
               to Forward Flow, LLC except for authorized support purpose.
               YForward Flow, LLC's Lead data will remain only in yForward Flow,
               LLC's instance of the platform and will only be transferred when
               a manual account transfer to another Forward Flow, LLC instance
               has been requested and approved by the user. Forward Flow, LLC
               will never distribute or share yForward Flow, LLC's Lead data
               unless requested to do so.
            </p>
            <p className="mb-3">
               Forward Flow, LLC Account Owners decide whether Hidden Leads are
               appropriate for the Forward Flow, LLC's teamers in their account.
               They can delegate the ability to hide leads Forward Flow, LLC's
               teaming their Permission Settings. All leads designated within an
               account database as Hidden Leads will only be visible to the
               Forward Flow, LLC's teamer who has added them, and any other
               Forward Flow, LLC's teamers they have assigned to that lead.
            </p>
            <p className="mb-3">7.8</p>
            <p className="mb-3">
               ACCOUNT TRANSFER PROCESS. An individual Forward Flow, LLC's
               teamer on a Forward Flow, LLC account may coordinate with Forward
               Flow, LLC to create a new and independent Forward Flow, LLC
               account at any time. Any Personal Leads, private email, text
               templates, or other settings that belong to that Forward Flow,
               LLC's teamer can be transferred from the sForward Flow, LLC'sce
               account to the destination account without the need for
               additional approval from the account owner. HoForward Flow, LLC's
               organizationver, if the Forward Flow, LLC's teamer also desires
               to transfer other account-level content that is not Hidden or
               Personal and belonging only to their individual login, approval
               mForward Flow, LLC's teamt be obtained by the sForward Flow,
               LLC'sce account owner prior to transfer taking place. This
               process can be coordinated with the Forward Flow, LLC Support
               Team.
            </p>
            <p className="mb-3">7.9</p>
            <p className="mb-3">
               TRANSLATION SERVICES. Certain built-in Forward Flow, LLC
               offerings allow for the translation of Member Content and default
               Forward Flow, LLC content within the Forward Flow, LLC CRM and
               Forward Flow, LLC Real Estate platforms. This content can be
               translated by automated integrations managed by Forward Flow, LLC
               or by manual input by the user as the Forward Flow, LLC's teamer.
               By utilizing these translation tools and services, the user agree
               that Forward Flow, LLC is not liable for translation accuracy or
               loss of bForward Flow, LLC's teaminess due to original or
               translated content.
            </p>
            <p className="mb-3">
               8. Loss of Data, Content, and Capacity Upon Cancellation
            </p>
            <p className="mb-3">
               If yForward Flow, LLC's Member Account or any offerings or Third
               Party offerings related to yForward Flow, LLC's Member Account
               are canceled, such Cancellation may caForward Flow, LLC's teame
               or result in the loss of certain content, features, or capacity
               of yForward Flow, LLC's Member Account, including any Member
               Content, visitor or Forward Flow, LLC's teamer data or other
               Forward Flow, LLC's teamage data retained therein, and including
               any domain name reservation or registration that was included in
               such offerings (collectively, &quot;Capacity Loss&quot;). You
               agree, understand and acknowledge that Forward Flow, LLC's
               organization shall have no liability or responsibility for any
               Capacity Loss.
            </p>
            <p className="mb-3">
               Within ninety (90) calendar days after the date of termination of
               the offerings and payment in full of all outstanding fees,
               Forward Flow, LLC will, after submission of a written request by
               the user, provide the user with access to download all exportable
               data (“CRM Data”) from yForward Flow, LLC's instance of the
               Forward Flow, LLC CRM. Forward Flow, LLC shall have no obligation
               to maintain or provide any CRM Data and Forward Flow, LLC
               reserves the right to delete CRM Data ninety (90) calendar days
               after the date of termination of the offerings.
            </p>
            <p className="mb-3">
               If CRM Data is deleted from yForward Flow, LLC's account either
               intentionally or unintentionally by an authorized admin Forward
               Flow, LLC's teamer within yForward Flow, LLC's account, Forward
               Flow, LLC shall have no obligation to restore this data to its
               previoForward Flow, LLC's team state. In addition, where Forward
               Flow, LLC may make attempts to assist in restoring deleted or
               lost CRM Data, no specific timeline for this process will be
               guaranteed.
            </p>
            <p className="mb-3">9. Third Party offerings</p>
            <p className="mb-3">
               The offerings may enable the user to engage and procure certain
               third party services and tools for enhancing yForward Flow, LLC's
               Member platform and yForward Flow, LLC's overall Forward Flow,
               LLC's teamer experience, including domain registrars from which
               the user may purchase a domain name for yForward Flow, LLC's
               Member platform, third party applications and widgets offered via
               the Site(s), third party Licensed Content, media distribution
               services, third party designers who may assist the user with
               yForward Flow, LLC's Member platform, etc. (collectively,
               &quot;Third Party offerings&quot;). We shall have no liability or
               responsibility for any Third Party offerings. We reserve the
               right, at any time and in Forward Flow, LLC's sole discretion, to
               sForward Flow, LLC's teampend, disable access to or remove from
               yForward Flow, LLC's Member Account, Member platform(s) and/or
               the offerings, any Third-Party offerings without any liability to
               the user or to any of yForward Flow, LLC's visitors or Forward
               Flow, LLC's teamers.
            </p>
            <p className="mb-3">
               Our offerings may contain links to third-party Forward Flow,
               LLC's organizationbsites or services that are not owned or
               controlled by Forward Flow, LLC. We have no control over, and
               assume no responsibility for, the content, privacy policies, or
               practices of any third-party Forward Flow, LLC's
               organizationbsites or services. You further acknowledge and agree
               that Forward Flow, LLC shall not be responsible or liable,
               directly, or indirectly, for any damage or loss caForward Flow,
               LLC's teamed or alleged to be caForward Flow, LLC's teamed by or
               in connection with Forward Flow, LLC's teame of or reliance on
               any such content, goods or services available on or through any
               such Forward Flow, LLC's organizationbsites or services. We
               strongly advise the user to read the terms and conditions and
               privacy policies of any third-party Forward Flow, LLC's
               organizationb sites or services that the user visit.
            </p>
            <p className="mb-3">
               10. Equal HoForward Flow, LLC's teaming Opportunity
            </p>
            <p className="mb-3">
               We are pledged to the letter and spirit of United States policy
               for the achievement of equal hoForward Flow, LLC's teaming
               opportunity. We encForward Flow, LLC'sage and support an
               affirmative advertising and marketing program in which there are
               no barriers to obtaining hoForward Flow, LLC's teaming
               becaForward Flow, LLC's teame of race, color, religion, sex,
               handicap, familial statForward Flow, LLC's team, or national
               origin. We endeavor to treat all parties fairly and honestly and
               to support equal hoForward Flow, LLC's teaming opportunities. We
               encForward Flow, LLC'sage Forward Flow, LLC's Forward Flow, LLC's
               teamers to do so as Forward Flow, LLC's organizationll.
            </p>
            <p className="mb-3">11. Copyrights and DMCA</p>
            <p className="mb-3">
               We respect the intellectual property rights of others, Forward
               Flow, LLC's organization act in accordance with Forward Flow,
               LLC's interpretation of the Digital Millennium Copyright Act
               (&quot;DMCA&quot;). If the user believe that yForward Flow, LLC's
               work has been copied or was otherwise Forward Flow, LLC's teamed
               in a way that constitutes copyright infringement, the user may
               notify CForward Flow, LLC's teamtomer Support of such
               infringement by phone at 1 (719) 639-3932 or by email Forward
               Flow, LLC's teaming support@forward-flow.com
            </p>
            <p className="mb-3">
               If Forward Flow, LLC's organization receive notice regarding a
               copyright infringement related to yForward Flow, LLC's Member
               Account or Member platform, Forward Flow, LLC's organization may
               cancel yForward Flow, LLC's Member Account, take yForward Flow,
               LLC's Member platform down or remove any Content in Forward Flow,
               LLC's sole discretion, with or without prior notice to the user.
               In such a case, the user may file an appropriate counter-notice
               in accordance with Section 512 of the&nbsp;.
            </p>
            <p className="mb-3">12. Termination</p>
            <p className="mb-3">
               We may terminate yForward Flow, LLC's access to all or any part
               of the offerings at any time, with or without caForward Flow,
               LLC's teame, with or without notice, and effective immediately,
               which may result in the forfeiture and destruction of all
               information associated with yForward Flow, LLC's membership. If
               the user wish to terminate yForward Flow, LLC's Account, the user
               may do so according to the terms outlined in this Agreement by
               following the instructions outlined on the Site or through the
               offerings. All provisions of these User Agreement which by their
               nature should survive termination shall survive termination,
               including, without limitation, licenses of User Content,
               ownership provisions, warranty disclaimers, indemnity and
               limitations of liability, and arbitration.
            </p>
            <p className="mb-3">
               13. Privacy and yForward Flow, LLC's Personal Information
            </p>
            <p className="mb-3">13.1</p>
            <p className="mb-3">
               For information about Forward Flow, LLC’s data protection
               practices, please read Forward Flow, LLC's Data Protection
               Guidelines which is hereby incorporated into this Agreement. This
               policy explains how Forward Flow, LLC's organization treat
               yForward Flow, LLC's personal information when the user access
               and utilize Forward Flow, LLC’s offerings.
            </p>
            <p className="mb-3">13.2</p>
            <p className="mb-3">Data Protection</p>
            <p className="mb-3">
               These User Agreement incorporate the&nbsp;Forward Flow, LLC Data
               Processing Agreement (“DPA”), when the GDPR applies to yForward
               Flow, LLC's Forward Flow, LLC's teame of Forward Flow, LLC’s
               offerings to process CForward Flow, LLC's teamtomer Data (as
               defined in the DPA). The DPA is effective as of 25 May 2018 and
               replaces and supersedes any previoForward Flow, LLC's teamly
               agreed data processing addendum betForward Flow, LLC's
               organizationen the user and Forward Flow, LLC relating to the
               Directive 95/46/EC.
            </p>
            <p className="mb-3">
               These User Agreement incorporate the&nbsp;UK GDPR
               Addendum&nbsp;when the UK GDPR applies to yForward Flow, LLC's
               Forward Flow, LLC's teame of Forward Flow, LLC’s offerings to
               process UK CForward Flow, LLC's teamtomer Data (as defined in the
               UK GDPR Addendum).
            </p>
            <p className="mb-3">
               These User Agreement incorporate the&nbsp;Standard Contractual
               ClaForward Flow, LLC's teames&nbsp;betForward Flow, LLC's
               organizationen controllers and processors approved by the
               European Commission Implementing Decision (EU) 2021/914 of 4 June
               2021 (the “SCCs”). The SCCs will only apply when: (i) the GDPR
               applies to yForward Flow, LLC's Forward Flow, LLC's teame of
               Forward Flow, LLC’s offerings to process CForward Flow, LLC's
               teamtomer Data; and (ii) CForward Flow, LLC's teamtomer Data is
               transferred either directly or via onward transfer, to a country
               outside of the European Economic Area not recognized by the
               European Commission as providing an adequate level of protection
               for personal data subject to GDPR (together a “Data Transfer”).
               When the user are a controller (as defined in the GDPR), the
               Controller-to-Processor ClaForward Flow, LLC's teames will apply
               to a Data Transfer.
            </p>
            <p className="mb-3">
               These User Agreement incorporate the Forward Flow, LLC Inc. CCPA
               Terms, when the CCPA applies to yForward Flow, LLC's Forward
               Flow, LLC's teame of the Forward Flow, LLC Inc. offerings to
               process Personal Information (as defined in the&nbsp;Data
               Protection Guidelines).
            </p>
            <p className="mb-3">14. Indemnification</p>
            <p className="mb-3">
               You agree to indemnify, defend, and hold harmless Forward Flow,
               LLC, their affiliates, and their respective directors, officers,
               employees, and agents from any and all third-party claims,
               actions, demands, investigations, expenses (including reasonable
               attorney’s fees and costs), losses or liabilities incurred by or
               asserted against Forward Flow, LLC or any of its indemnitees due
               to or arising out of: (a) yForward Flow, LLC's access to or
               Forward Flow, LLC's teame of the offerings; (b) yForward Flow,
               LLC's breach of these User Agreement; (c) yForward Flow, LLC's
               violation of any law, rule, or regulation applicable to the user;
               (d) any dispute betForward Flow, LLC's organizationen the user
               and any third party; (e) any User Materials the user upload to,
               or otherwise make available through, the offerings; (f) yForward
               Flow, LLC's willful misconduct; and (g) any other party’s access
               to or Forward Flow, LLC's teame of the offerings (i) Forward
               Flow, LLC's teaming yForward Flow, LLC's account and password or
               (ii) resulting from yForward Flow, LLC's failure to maintain
               appropriate security protocols related to yForward Flow, LLC's
               account with Forward Flow, LLC. Forward Flow, LLC reserves the
               right, at their own expense, to assume the exclForward Flow,
               LLC's teamive defense and control of any matter otherwise subject
               to indemnification by the user, and in that case, the user agree
               to cooperate with Forward Flow, LLC’s defense of that claim.
            </p>
            <p className="mb-3">15. Disclaimer of Warranties</p>
            <p className="mb-3">15.1</p>
            <p className="mb-3">
               We provide the Sites and the offerings on an &quot;as is,&quot;
               &quot;where is,&quot; &quot;with all faults&quot;, and &quot;as
               available&quot; basis, without any warranties of any kind,
               including any implied warranties or conditions of
               merchantability, fitness for a particular purpose, and
               non-infringement. We specifically do not represent or warrant
               that the Sites or offerings (or any part, feature or Content
               thereof) are complete, accurate, of any certain quality, reliable
               or secure in any way, suitable for or compatible with any of
               yForward Flow, LLC's (or yForward Flow, LLC's visitors or Forward
               Flow, LLC's teamers) contemplated activities, devices, operating
               systems, browsers, software or tools (or that they will remain as
               such at any time), or comply with any laws applicable to the user
               or yForward Flow, LLC's visitors or Forward Flow, LLC's teamers
               or that their operation will be free of any virForward Flow,
               LLC's teames, bugs or other harmful components or program
               limitations. Notwithstanding anything to the contrary contained
               herein, under no circumstances may Forward Flow, LLC's
               organization be considered as a &quot;publisher&quot; of any
               Member Content, and Forward Flow, LLC's organization do not in
               any way endorse any Member Content or assume any liability for
               any Member Content uploaded, posted, published and/or made
               available by any Member or any other party on and/or through the
               offerings. You acknowledge that (1) there are risks in Forward
               Flow, LLC's teaming the offerings and/or connecting and/or
               dealing with any Third-Party offerings in connection with
               offerings, (2) Forward Flow, LLC's organization cannot and do not
               guarantee any specific outcomes from such Forward Flow, LLC's
               teame and/or interactions, and (3) the user hereby assume all
               such risks, liabilities and/or harm of any kind arising in
               connection with and/or resulting from such interactions.
            </p>
            <p className="mb-3">15.2</p>
            <p className="mb-3">
               Forward Flow, LLC shall have no liability or responsibility of
               any kind or nature whatsoever for compliance with RESPA
               including, but not limited to, Section 8 of RESPA or any
               regulations adopted under RESPA with respect to any joint Forward
               Flow, LLC's teame agreement, marketing service agreement or other
               similar agreement or arrangement whereby two or more Users share
               the cost of and right to access and Forward Flow, LLC's teame the
               Forward Flow, LLC Sites and offerings. Each User that enters into
               any joint Forward Flow, LLC's teame agreement, marketing service
               agreement or other similar agreement, specifically acknowledges
               and agrees that such User is responsible for compliance with
               RESPA and the regulations adopted thereunder. Each User further
               acknowledges that, in accessing and Forward Flow, LLC's teaming
               the Sites and Service on a shared basis, such User is not relying
               upon any representations or warranties made by Forward Flow, LLC
               or any of its affiliates that such shared Forward Flow, LLC's
               teame complies with RESPA and Forward Flow, LLC expressly
               disclaims any and all such representations or warranties.
            </p>
            <p className="mb-3">16. Limitation of Liability</p>
            <p className="mb-3">16.1</p>
            <p className="mb-3">
               LIABILITY LIMITS. In no event shall Forward Flow, LLC's
               organization, Forward Flow, LLC's affiliates and each of Forward
               Flow, LLC's and their respective employees, contractors,
               directors, suppliers, licensors, and representatives, be liable
               under contract, tort, strict liability, negligence, or any other
               legal or equitable theory with respect to the services for any
               lost profits, data loss, cost of procurement of substitute goods,
               accommodations, rights or services, or special, indirect,
               incidental, punitive, compensatory, or consequential damages of
               any kind whatsoever, substitute goods or services (hoForward
               Flow, LLC's organizationver arising), or for any direct damages
               in excess of (in the aggregate) the lesser of (a) fees paid to
               Forward Flow, LLC's team for the particular services during the
               immediately previoForward Flow, LLC's team three (3) month period
               or (b) $100.00.
            </p>
            <p className="mb-3">16.2</p>
            <p className="mb-3">
               ACKNOWLEDGEMENT. You specifically acknowledge that Forward Flow,
               LLC's organization shall not be liable for (i) Forward Flow,
               LLC's teamer Content, (ii) the defamatory, offensive, or illegal
               conduct of any third party, or (iii) the condition, legality, or
               suitability of any property, and that the risk of harm or damage
               from the foregoing rests solely and entirely with the user.
            </p>
            <p className="mb-3">
               RELEASES. You shall and hereby do release Forward Flow, LLC's
               team from all liability for the user having acquired or not
               acquired hoForward Flow, LLC's teaming through the offerings. You
               hereby release Forward Flow, LLC's team and Forward Flow, LLC's
               directors, officers, employees, agents, subsidiaries, Affiliates,
               successors, predecessors, assigns, heirs, service providers,
               insurers, investors, attorneys, advisors, and suppliers from all
               claims, demands, and damages of every kind and nature, known and
               unknown, direct and indirect, sForward Flow, LLC's teampected and
               unsForward Flow, LLC's teampected, disclosed and undisclosed,
               arising out of or in any way related to Content accessed through
               the offerings, or any interactions with others arising out of or
               related thereto, and the user expressly waive the provisions of
               any local law, which provides in substance: “A general release
               does not extend to claims which the creditor does not know or
               sForward Flow, LLC's teampect to exist in his favor at the time
               of executing the release, which, if known by him mForward Flow,
               LLC's teamt have materially affected his settlement with the
               debtor,” and all similar code provisions in any jurisdiction.
            </p>
            <p className="mb-3">
               Forward Flow, LLC shall have no liability or responsibility of
               any kind or nature whatsoever for compliance with RESPA, any
               other section of RESPA or any regulations adopted thereunder with
               respect to any joint Forward Flow, LLC's teame agreement,
               marketing service agreement or other similar agreement or
               arrangement whereby two or more Users share the cost of and right
               to access and Forward Flow, LLC's teame the Forward Flow, LLC
               Sites and offerings. Each User that enters into any joint Forward
               Flow, LLC's teame agreement, marketing service agreement or other
               similar agreement, specifically acknowledges and agrees that such
               User is responsible for compliance with RESPA and the regulations
               adopted thereunder. Each User further acknowledges that in
               accessing and Forward Flow, LLC's teaming the Sites and Service
               on a shared basis such User is not relying upon any
               representations or warranties made by Forward Flow, LLC or any of
               its affiliates that such shared Forward Flow, LLC's teame
               complies with RESPA and Forward Flow, LLC expressly disclaims any
               and all such representations or warranties.
            </p>
            <p className="mb-3">17. Governing Law and Jurisdiction</p>
            <p className="mb-3">
               These User Agreement shall be governed by and construed in
               accordance with the laws of the state of Arizona, including its
               conflicts of law rules, in the United States of America, and the
               United Nations Convention on Contracts for the International Sale
               of Goods shall not be applicable hereto. Without limiting the
               arbitration obligations set forth above, the user agree to submit
               to the jurisdiction and venue of the state and Federal cForward
               Flow, LLC'sts of Phoenix, Arizona for the purposes of these User
               Agreement.
            </p>
            <p className="mb-3">
               You agree that any caForward Flow, LLC's teame of action arising
               out of or related to the services or Forward Flow, LLC's team
               mForward Flow, LLC's teamt commence within one (1) year after the
               caForward Flow, LLC's teame of action accrues, otherwise, any
               such caForward Flow, LLC's teame of action is permanently barred.
            </p>
            <p className="mb-3">18. General</p>
            <p className="mb-3">18.1</p>
            <p className="mb-3">
               NOTICES. We may provide the user with notices in any of the
               following methods: (1) via the offerings, including by a banner
               or pop-up within the applicable Site(s), Member Account or
               elsewhere; (2) by e-mail, sent to the e-mail address the user
               provided Forward Flow, LLC's team; and/or (3) through any other
               means, including any phone number or physical address the user
               provided Forward Flow, LLC's team. Such notice to the user will
               be deemed received and effective upon receipt or tForward Flow,
               LLC's organizationnty-fForward Flow, LLC's (24) hForward Flow,
               LLC'ss after it was published or sent through any of the
               foregoing methods, unless otherwise indicated in the notice.
            </p>
            <p className="mb-3">18.2</p>
            <p className="mb-3">
               HEADINGS. Any heading, caption or section title here is provided
               only for convenience, and shall not be Forward Flow, LLC's teamed
               to interpret any section or provision hereof.
            </p>
            <p className="mb-3">18.3</p>
            <p className="mb-3">
               LANGUAGE. The terms of this Agreement Forward Flow, LLC's
               organizationre written in English. If a translated (non-English)
               version of this Agreement conflicts in any way with their English
               version, the provisions of the English version shall prevail.
            </p>
            <p className="mb-3">18.4</p>
            <p className="mb-3">
               RELATIONSHIP. This Agreement, yForward Flow, LLC's access to the
               Site(s), and yForward Flow, LLC's Forward Flow, LLC's teame of
               the offerings, do not, and shall not be construed to create any
               partnership, joint venture, employer-employee, agency, or
               franchisor-franchisee relationship betForward Flow, LLC's
               organizationen Forward Flow, LLC's team and the user.
            </p>
            <p className="mb-3">18.5</p>
            <p className="mb-3">
               ENTIRE AGREEMENT. This Agreement and any other legal or fee
               notices provided to the user by Forward Flow, LLC's team, shall
               constitute the entire agreement betForward Flow, LLC's
               organizationen Forward Flow, LLC's team concerning the subject
               matter hereof and all prior understandings shall be deemed merged
               herein.
            </p>
            <p className="mb-3">18.6</p>
            <p className="mb-3">
               ASSIGNMENT. You may not assign or transfer any of yForward Flow,
               LLC's rights and obligations hereunder.
            </p>
            <p className="mb-3">18.7</p>
            <p className="mb-3">
               SEVERABILITY; NO WAIVER. If any provision of the Agreement is
               deemed by a cForward Flow, LLC'st of competent jurisdiction to be
               invalid, unlawful, void, or for any reason unenforceable, then
               such provision shall be deemed severable and will not affect the
               validity and enforceability of any of the remaining provisions of
               this Agreement. No Waiver of any breach or default of any of the
               terms of the Agreement shall be deemed to be a waiver of any
               preceding or subsequent breach or default.
            </p>
            <p className="mb-3">19. User Disputes</p>
            <p className="mb-3">
               We reserve the right, without any obligation, to intervene in or
               monitor disputes betForward Flow, LLC's organizationen Forward
               Flow, LLC's Forward Flow, LLC's teamers. You agree to cooperate
               with and assist Forward Flow, LLC's team in good faith, and to
               provide Forward Flow, LLC's team with such information and take
               such actions as Forward Flow, LLC's organization may reasonably
               request, in connection with any disputes involving the user.
               Although Forward Flow, LLC's organization may moderate content or
               disputes in Forward Flow, LLC's discretion, Forward Flow, LLC's
               organization have no authority to legally bind third parties or
               force them to resolve complaints or disputes. Any efforts or
               statements made by Forward Flow, LLC's team to intervene in or
               moderate disputes is superseded by this provision, which may not
               be modified, waived, or released except by a written agreement,
               dated and signed by Forward Flow, LLC's Chief Executive Officer
               and dated and signed by the individual or entity to whom the
               modification, waiver, or release is granted.
            </p>
            <p className="mb-3">20. MiscellaneoForward Flow, LLC's team</p>
            <p className="mb-3">
               Entire Agreement. These User Agreement, together with any
               state-mandated disclosure forms provided by Forward Flow, LLC's
               team to the user separately, are the entire agreement betForward
               Flow, LLC's organizationen the user and Forward Flow, LLC's team
               with respect to the offerings and supersede all prior or
               contemporaneoForward Flow, LLC's team communications and
               proposals (whether oral, written or electronic) betForward Flow,
               LLC's organizationen the user and Forward Flow, LLC's team with
               respect to the offerings.
            </p>
            <p className="mb-3">21. Contact Us</p>
            <p className="mb-3">
               If the user have any questions, complaints, or claims with
               respect to the offerings, the user may contact Forward Flow,
               LLC's team by any of the options listed below:
            </p>
            <p className="mb-3">Forward Flow, LLC, LLC</p>
            <p className="mb-3">524 S Tejon St.</p>
            <p className="mb-3">Colorado Springs, CO 80903</p>
            <p className="mb-3">(719) 639-3932</p>
         </div>
      </div>
   )
}

export default Terms
